

/**公共引用 */
import React from 'react';
import $ from 'jquery';
import NavMenu from '../../components/navMenu/navMenu';
import HeaderMenu from '../../components/headerMenu/headerMenu';
import '../../assets/css/common.less';
import MyLoading from '../../components/showLoading/showLoading';
import ShowWarn from '../../components/showWarn/showWarn';
import { Input, Select, Tabs, Button, Pagination, Checkbox, Radio, Message, Loading, Tooltip, Tag, Dialog, MessageBox, Popover } from 'element-react';
import { requests, getToken, loadZhuKeToken, getLoginShopInfo, messageShow, isNotNull, systemConfig, getZkShopName, getTaoteShopName, fromClassName } from '../../utils/http';
import MyPopover from '../../components/popover/index.jsx';
import ShowModal from '../../components/showModal/index.jsx';
import SelectCategoryModule from '../../components/selectCategoryModule';
import PlatformName from '../../components/platformName/index.jsx';
import { TaoteProductParameRequest, QuerySupplierProductsRequest, QueryBdyProducts,QueryFenXiaoProducts, GetFenXiaoProductConfig, AddSiteLogRequest,SaveOrderConfigRequest,BatchListingMobileByProductIdListV2Request,GetAliChoicenessProductDetailRequest,GetAliCategorysRequest } from '../../utils/api';
import SelectBox from '../../components/selectBox/index.jsx';
import NewUserGuide from '../../components/newUserGuide/index.jsx';
import { huoyuanLink } from '../../utils/index';
import { getStorage,setStorage } from '../../utils/common';
import PreviewDistributionList from '../../components/previewDistributionList';
import MyCascader from '../../components/cascader/index.jsx';
import { otherExposureReport } from '../../utils/alibabareport.js';

/** */
import './offerSearch.less';


class offerSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alibabaPageKey:'xpzx',
            shopList: [],
            openUrl: "https://s.1688.com/erpoffer/offer_search.html?keywords=&charset=utf8&erp_app_key=8076003",
            findValue: 'goods',
            isPifatuanProduct: true,
            isLoading: false,
            hasLoadBorder: false,//加载，背景框
            loadingTitle: "加载中...",

            //分页 
            pagesize: 20,
            totals: 0,
            current: 1,

            categoryList: [],//类目列表
            aliPoolCategoryList: [],//多渠道面类目列表
            tagList: [],//标签列表

            productList: [],//精选列表
            selectProductNumber: 0,//选中的数量

            orderby: "",
            sort: "0",
            isSupportEncryptCreateOrderSupplier: false,//支持密文下单供应商的商品

            offerIdList: [],//选择的商品
            isShowPuHuo: false,

            taskCodeRes: { taskCode: '', isPost: false, allNumber: 0, successNumber: 0, errorNumber: 0, errorList: [] },//铺货后，返回的任务code
            isShowTaskCodeRes: false,

            //====================铺货前，显示商品和类目匹配 ============================
            isShowByDistributionSelectCategory: false,
            supplierProductListByBatch: [],//铺货前，获取商品列表
            affirmByeBatchDistributionByData: {},

            selectCategoryByProductId: '',//选择类目的商品Id
            selectCategoryByShopId: 0,//选择类目的店铺Id
            selectCategoryByPlatform: '',//选择类目的平台
            selectCategoryValueList: [],
            //isNotSelectCateforyNumber: 0,//没有选择类目
            isShowOverlookByCategorySelect: false,
            //====================铺货前，显示商品和类目匹配 end============================


            versionsDistinction: [],//版本金额等区别
            functionDistinction: [],//版本功能区分
            payUserList: [],//订购用户滚动数据
            PayInfoList: [],//优惠券数组
            PayIndex: 1,//套餐类型
            upgradeUrl: '',//升级链接
            lingQuUpgradeUrl: '',// 领劵升级

            isShowAddShopByUpgradeApp: false,//免费版，超过5个的弹窗
            isShowChoosePlatform: false,  //显示添加平台弹窗
            isShowAuthShop: false,//是否完成授权弹窗
            selectPlatform: 'TouTiao',


            isShowReachListingCount: false,
            changeSearchNav: '找货源',
            platformNav: [
                // { Title: "淘特货源", Name: "tthy", isSelect: false, isHot: true }, 
                { Title: "分销严选", Name: "jxhy", isSelect: true, isHot: false }, 
                { Title: "精选货盘", Name: "bdyhy", isSelect: false, isHot: true},
                { Title: "1688推荐货源", Name: "fxhy", isSelect: false, isHot: false, isEncryptTag: true }
            ],
            selectPlatformNav: 'jxhy',
            isShowFiltbarMoreOperate: false,
            sortNav: [
                { Title: "", Name: "综合", IsSelect: true, isIcon: false },
                { Title: "salesCnt", Name: "销量", IsSelect: false, isIcon: true, childSort: true },
                { Title: "minPrice", Name: "价格", IsSelect: false, isIcon: true, childSort: true },

            ],
            //============================精选货源===========================
            jxhyParames: {
                filters:[],
                filtersRate48H:[],
                filtersRate24H:[],
                filtersShip:[],
                filtersCiphertext:[],

                showItemByfiltersRate24H:false,
            },

            /**=========================淘特货源相关========================= */
            taoteProductParame: {
                categorys: [],
                pools: [],
                features: [],
                orderBys: [],
                sort: "desc",
                list: [],//相关商品
                priceChecked: false,//
            },//淘特商品查询参数
            queryTaoteProductDto: {
                Keyword: '',//商品关键字
                OrderBy: '',//排序字段
                Sort: '',//1 降序,0 升序
                MinPrice: '',
                MaxPrice: '',
                CategoryId: '',
                SourcePlatform: 'TaoteZhuKe',
                Feature: {}
            },/*查询淘特货源dto*/

            //===============春节不打烊=====================
            bdyProductParame: {
                priceChecked: false,
                categorys: [],
                offerPoolldList: [ 
                    { Title: "168624937", Name: "春节不打烊抖音专场", IsSelect: true},
                    { Title: "173372326", Name: "春节不打烊-仓发货", IsSelect: false},
                    { Title: "172135216", Name: "玩具供应链", IsSelect: false},
                ],
                features: [
                    {
                        FeatureName: '发货时效',
                        FeatureId: 'SendGoodService',
                        Option: [
                           
                        ]
                    }
                    // , {
                    //     FeatureName: '到货保障',
                    //     FeatureId: 'DeliveredService',
                    //     Option: [
                    //         { Item1: '3天到货保障', Item2: 3, Text: '3天', },
                    //         { Item1: '5天到货保障', Item2: 5, Text: '5天', },
                    //         { Item1: '7天到货保障', Item2: 7, Text: '7天', }
                    //     ]
                    // }
                ]
            },
            queryBdyProductDto: {
                Keyword: '',//商品关键字
                OrderBy: '',//排序字段
                Sort: '',//1 降序,0 升序
                // MinPrice: '',
                // MaxPrice: '',
                CategoryId: ''
            },
            bdySortNav: [
                { Title: "", Name: "综合", IsSelect: true, isIcon: false },
                { Title: "minPrice", Name: "价格", IsSelect: false, isIcon: true, childSort: true },
            ],
            bdyByisJxhy:false,
            bdyBybtwlybt:false,

            //===============春节不打烊 end =====================



            fenxiaoProductParame: {
                priceChecked: false,
                categorys: [],
                features: [
                    {
                        FeatureName: '发货时效',
                        FeatureId: 'SendGoodService',
                        Option: [
                            { Item1: '24小时发货', Item2: 24, Text: '24小时', },
                            { Item1: '48小时发货', Item2: 48, Text: '48小时', },
                            { Item1: '72小时发货', Item2: 72, Text: '72小时', },
                            { Item1: '7天发货', Item2: 168, Text: '7天', }
                        ]
                    }, {
                        FeatureName: '到货保障',
                        FeatureId: 'DeliveredService',
                        Option: [
                            { Item1: '3天到货保障', Item2: 3, Text: '3天', },
                            { Item1: '5天到货保障', Item2: 5, Text: '5天', },
                            { Item1: '7天到货保障', Item2: 7, Text: '7天', }
                        ]
                    }
                ]
            },
            queryFenXiaoProductDto: {
                Keyword: '',//商品关键字
                OrderBy: '',//排序字段
                Sort: '',//1 降序,0 升序
                MinPrice: '',
                MaxPrice: '',
                CategoryId: ''
            },
            /*查询分销商品信息 */
            fenxiaoSortNav: [
                { Title: "", Name: "综合", IsSelect: true, isIcon: false },
                // { Title: "salesCnt", Name: "销量", IsSelect: false, isIcon: true,childSort:true },
                { Title: "minPrice", Name: "价格", IsSelect: false, isIcon: true, childSort: true },
                { Title: "sendGoodService", Name: "发货时效", IsSelect: false, isIcon: true, childSort: true, width: "100px" },
            ],
           

            /**=========================当前登录店铺信息==================================== */
            selectShopId: undefined,//店铺id
            selectShopName: undefined,//店铺名
            selectplatformType: undefined,//对应平台
            isShowNextCurrent: false,  //是否展示下一页按钮
            isSowBanner: false,
            isShowMySelect: false,
            searchSelectPatform: [
                { Id: 1, Title: '抖音', Icon: 'TouTiao', isActive: false,value: 'douyin' },
                { Id: 2, Title: '快手', Icon: 'KuaiShou', isActive: false,value:'kuaishou' },
            ],
            searchAliPoolSelectPatform:[],
            ciphertextOrderSetDailog:false,
            showPreviewDistributionDailog:false,
            selectPreviewProductList:[],  //预览铺货商品表
            isCategoryShow:false, // 预览分类弹窗
            isCategory: {},  // 预览分类类目信息
            selectCategoryId: 0, // 预览分类弹窗已选分类id
            selectCategory:{},  //  已选分类
            isCategoryThat:null,
            
            isAliPoolCategoryShow:false, // 预览分类弹窗
            isAliPoolCategory: {},  // 预览分类类目信息
            selectAliPoolCategoryId: 0, // 预览分类弹窗已选分类id
            selectAliPoolCategory:{},  //  已选分类
            isAliPoolCategoryThat:null,
        };
    }
    //#region  页面挂载
    componentWillMount() {
        // if (systemConfig.isZk5() && systemConfig.isTouTiao()) {
        //     this.state.selectPlatformNav = 'jxhy'
        //     this.state.platformNav = [{ Title: "淘特货源", Name: "tthy", isSelect: false, isHot: true }, { Title: "1688精选货源", Name: "jxhy", isSelect: true, isHot: false }, { Title: "1688推荐货源", Name: "fxhy", isSelect: false, isHot: false, isEncryptTag: true }];
        // }
        // else if (systemConfig.isZk5()) {
        //     this.state.selectPlatformNav = 'jxhy'
        //     this.state.platformNav = [{ Title: "淘特货源", Name: "tthy", isSelect: false, isHot: true }, { Title: "1688精选货源", Name: "jxhy", isSelect: true, isHot: false }, { Title: "货源中心", Name: "hyzx", isSelect: false, isHot: false }]
        // }
        // else 
        if (systemConfig.isTouTiao()) {
            this.state.selectPlatformNav = 'jxhy'
            this.state.platformNav = [
                // { Title: "淘特货源", Name: "tthy", isSelect: false, isHot: true },
                 { Title: "分销严选", Name: "jxhy", isSelect: true, isHot: false }, 
                 { Title: "精选货盘", Name: "bdyhy", isSelect: false, isHot: true},
                 { Title: "1688推荐货源", Name: "fxhy", isSelect: false, isHot: false, isEncryptTag: true }
                ]
        }
    }
    componentDidMount(props) { //组件挂载到DOM渲染后被执行，只会执行一次。
        //this.loadShopList();
        

        var zhukeToken = getToken();
        var that = this;
        this.loadCategoryTag();//初始化类目和标签
         //初始化多媒体免单分类
         this.loadAliPoolCategoryTag();
        if (zhukeToken != "") {
            that.loadData();
            //this.loadCategoryTag();//初始化类目和标签
            // this.loadTaoteProductParam();
            this.loadFenxiaoParame();
            this.loadAliCategorys();
            otherExposureReport(this.state.alibabaPageKey);                  
        }
        else {
            setTimeout(() => {
                var zhukeTokenTwo = getToken();
                if (zhukeTokenTwo == "") {
                    var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
                    //var hasZhukeLoginShopTokens = "";//测试。
                    if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
                        loadZhuKeToken(hasZhukeLoginShopTokens);
                        that.loadData();
                        setTimeout(() => {
                            var zhukeTokenThree = getToken();
                            if (zhukeTokenThree != "") {
                                //that.loadData();
                            }
                            else
                                that.setState({ isShowWarn: true });

                            //this.loadCategoryTag();//初始化类目和标签
                            // this.loadTaoteProductParam();
                            this.loadFenxiaoParame();
                            this.loadAliCategorys();
                        }, 500);
                    } else
                        that.setState({ isShowWarn: true });
                } else {
                    that.loadData();
                    // this.loadTaoteProductParam();
                    this.loadFenxiaoParame();
                    this.loadAliCategorys();
                    // this.loadCategoryTag();//初始化类目和标签
                    this.loadList();  // 获取列表数据
                }
            }, 500);

        }

        var isShowBannerObjString = localStorage.getItem('isShowBannerObj') || null;
        if (isShowBannerObjString) {
            let isShowBannerObj = JSON.parse(isShowBannerObjString);
            this.setState({
                isSowBanner: isShowBannerObj.isShowBanner
            })
        } else {
            this.setState({
                isSowBanner: true
            })
        }
        setTimeout(() => {
            AddSiteLogRequest({
                SiteType: 'pc',
                OperatorType: 'to_offerSearch_shop',
                Remark: '访问货源中心'
            })
        }, 2000);

        document.onclick = () => {
            this.setState({ isShowMySelect: false })
        }
    }

    loadData = () => {
        var shopInfo = getLoginShopInfo();
        var that = this;
        this.state.shopList = [{
            Id: shopInfo.loginShopId,
            ShopName: shopInfo.loginShopName,
            PlatformType: shopInfo.loginShopPlatformType,
            IsChecked: true,
            AuthUrl: '',
            PayUrl: ''
        }];
        // this.setState({
        //     selectShopId: shopInfo.loginShopId,
        //     selectShopName: shopInfo.loginShopName,
        //     selectplatformType: shopInfo.loginShopPlatformType,
        // })
        // if (systemConfig.isZk5() && systemConfig.isTouTiao()) {
        //     this.state.selectPlatformNav = 'jxhy'
        //     this.state.platformNav = [{ Title: "淘特货源", Name: "tthy", isSelect: false, isHot: true }, { Title: "1688精选货源", Name: "jxhy", isSelect: true, isHot: false }, { Title: "1688推荐货源", Name: "fxhy", isSelect: false, isHot: false, isEncryptTag: true }];
        // }
        // else if (systemConfig.isZk5()) {
        //     this.state.selectPlatformNav = 'jxhy'
        //     this.state.platformNav = [{ Title: "淘特货源", Name: "tthy", isSelect: false, isHot: true }, { Title: "1688精选货源", Name: "jxhy", isSelect: true, isHot: false }, { Title: "货源中心", Name: "hyzx", isSelect: false, isHot: false }]
        // }
        // else 
        if (systemConfig.isTouTiao()) {
            this.state.selectPlatformNav = 'jxhy'
            this.state.platformNav = [
                // { Title: "淘特货源", Name: "tthy", isSelect: false, isHot: true },
                 { Title: "分销严选", Name: "jxhy", isSelect: true, isHot: false }, 
                 { Title: "精选货盘", Name: "bdyhy", isSelect: false, isHot: true},
                 { Title: "1688推荐货源", Name: "fxhy", isSelect: false, isHot: false, isEncryptTag: true }
                ];
        }
    }
    loadAliCategorys = async() =>{
     
        const res = await GetAliCategorysRequest();
        
        if(res.Success){
            const categorys = (res.Data && res.Data.List) || [];
            const categoryMap = this.converCategroys(categorys);
            this.setState({
                categoryMap:categoryMap
            })
            console.log(categoryMap);
        }
    }
      //多媒体分类加载
      loadAliPoolCategoryTag=()=>{
        if (this.state.isShowWarn)
            return;
        var that = this;
        //开启动画
        that.setState({ isLoading: true });
        requests({
            url: "/ShopCommon/GetAliPoolProductSearchConditionConfig",
            //shopType: true,
            data: {},
            success: function (res) {

                that.setState({ isLoading: false }); //关闭动画
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                    return;

                if (res.Success) {
                   
                    var categoryList = res.Data.Categorys;
                    var categorys = res.Data.AliJson_Categorys;
                    var poolList = res.Data.AlibabaPoolPallets;

                    for (let c = 0; c < categoryList.length; c++) {
                        categoryList[c].checked = false;
                    }

                    for (let c = 0; c < poolList.length; c++) {
                        poolList[c].checked = false;
                    }
                    const categoryMap = that.converCategroys(categorys);
                    var selectPlatForm= that.converSearchAliPoolSelectPatform(res.Data.SupportEncryptChannel);   
                    console.log(categoryMap);
                    that.setState({
                        searchAliPoolSelectPatform:selectPlatForm,
                        aliPoolCategoryList: categoryList,
                        aliPoolCategoryMap: categoryMap,
                        aliPoolList:poolList
                    });
                    that.state.bdyProductParame.features[0].Option= that.convertToFeatherOpinion(res.Data.SendGoodService);
                    that.loadList(true);//加载列表
                } else {
                    messageShow("获取类目失败：" + res.Message, 'error');
                }
            },
        });
    }
    convertToFeatherOpinion(sendGoodService)
    {
        
        const map = [];
       for(let it of sendGoodService){
         var item={ Item1: it.text, Item2: it.key, Text:it.desc, };
         map.push(item);
       }
       return map;

    }

    categoryRender(categorys,currentCategory){

        const eles = [];

        while(true){
            if(!categorys || Object.keys(categorys).length == 0)
                break;
            // if(!categorys.show)
            //     break;
            let nextCategory;
            const ele = <ul className='ph-filtbar-up-content-category-warp-ul'>
                {
                    Object.keys(categorys).map((categoryId,index) =>{
                        nextCategory = categorys[categoryId].children;
                        const curCategory = categorys[categoryId];
                        const temp = <li className={fromClassName({
                                'ph-filtbar-up-content-category-warp-ul-li':true
                            })} onClick={()=>{ this.checkedCategory(curCategory)}}>
                            { curCategory.category_name +  curCategory.checked }
                            </li>

                        return temp;
                    })
                }
            </ul>
            eles.push(ele);
            categorys = nextCategory;
        }

        return eles;
    }
    showCategory (category,element){
        const {selectCategory} = this.state;
        if (selectCategory.category_id == category.category_id) {
            this.setState({
                selectCategory: {},  
                selectCategoryId:  ''
            },()=>{
                this.loadList();
            })
            return
        }
        if (this.timer) clearTimeout(this.timer);
        if (!category ) return
        const _element = document.getElementById(element);
        let _height = $('.ph-filtbar-up-content-category').height();
        $('.ph-filtbar-up-content-category-warp').css({top:parseInt(_height)+20})
        if (category.children) {
            category.children = Object.values(category.children) || []
        }
        this.timer = setTimeout(() => {
            this.setState({
                isCategory: category,
                isCategoryShow: true,
                isCategoryThat:_element
                // isCategoryShow: true
            })
        }, 200);
        // this.state.categorys.map()
        
    }
    hideCategory(selectItem) {
        const {isCategory} = this.state;
        this.timer = setTimeout(() => {
            this.setState({
                selectCategory:isCategory,  //  已选分类
                selectCategoryId: selectItem.category_id || '',
                isCategoryShow: false
            },()=>{
                this.loadList();
            });
        }, 200);
    }
    showAliPoolCategory (category,element){
        const {selectAliPoolCategory} = this.state;
        if (selectAliPoolCategory.category_id == category.category_id) {
            this.setState({
                selectAliPoolCategory: {},  
                selectAliPoolCategoryId:  ''
            },()=>{
                this.loadList();
            })
            return
        }
        if (this.timer) clearTimeout(this.timer);
        if (!category ) return
        const _element = document.getElementById(element);
        let _height = $('.ph-filtbar-up-content-category').height();
        $('.ph-filtbar-up-content-category-warp').css({top:parseInt(_height)+20})
        if (category.children) {
            category.children = Object.values(category.children) || []
        }
        this.timer = setTimeout(() => {
            this.setState({
                isAliPoolCategory: category,
                isAliPoolCategoryShow: true,
                isAliPoolCategoryThat:_element
            })
        }, 200);
        
    }
    hideAliPoolCategory(selectItem) {
       
        const {isAliPoolCategory} = this.state;
        this.timer = setTimeout(() => {
            this.setState({
                selectAliPoolCategory:isAliPoolCategory,  //  已选分类
                selectAliPoolCategoryId: selectItem.category_id || '',
                isAliPoolCategoryShow: false
            },()=>{
                this.loadList();
            });
        }, 200);
    }
    getAliPoolCategorySelectId()
    {
        const {selectAliPoolCategoryId} = this.state
        var categoryList = this.state.aliPoolCategoryList;
        var categoryId = 0;
        categoryList.forEach(t => {
            if (t.checked)
                categoryId = t.Id;
        });
       
        if (selectAliPoolCategoryId != 0) {
            categoryId = selectAliPoolCategoryId
        }
        const selectCategorys = this.getAliPoolSelectCategory();
        if(selectCategorys && selectCategorys.length > 0){
            const selectCategory = selectCategorys[selectCategorys.length - 1];
            categoryId = selectCategory.category_id;
        }
        return categoryId;

    }
    checkedCategory(category){
        const checked = !category.checked;
        this.setFullChecked(this.state.categoryMap,false)
        if(checked) this.setParentChecked(this.state.categoryMap,category,true)
        this.loadList();
    }
    setFullChecked(current_category,value){
        const current_categoryIds = Object.keys(current_category)
        if(current_categoryIds.length == 0)
            return;
        for(let category_id of current_categoryIds){
          const category = current_category[category_id];
          category.checked = value;
          this.setFullChecked(current_category[category_id].children)
        }
    }
    setParentChecked(all_categorys,category,value){
        let current_category = all_categorys
        for (let index = category.cate_path.length - 1; index >= 0; index--) {
          const temp_path = [...category.cate_path]
          temp_path.splice(index + 1)
          current_category = this.findCategory(all_categorys,temp_path)
          if(current_category)
            current_category.checked = value;
        }
    }
      //根据路径查找类目
    findCategory(all_categorys,cate_path){
        let current_category = all_categorys;
        for (let index = 0; index < cate_path.length; index++) {
            const path = cate_path[index];
            if(index == cate_path.length - 1){
                current_category = current_category[path]
            }else{
                current_category = current_category[path].children
            }
        }
        return current_category
    }
    getSelectCategory(current_category){
        current_category = current_category || this.state.categoryMap;
        if(!current_category) return;
        const current_categoryIds = Object.keys(current_category)
        let data = []
        for(let category_id of current_categoryIds){
          const category = current_category[category_id];
          if(category.checked)
            data.push({
              category_id:category.category_id,
              category_name:category.category_name,
              cate_path:category.cate_path,
              full_name:category.cate_name.join(' > '),
            })
          else{
            const children = this.getSelectCategory(category.children)
            data = data.concat(...children)
          }
        }
        return data
      }
      getAliPoolSelectCategory(current_category){
        current_category = current_category || this.state.aliPoolCategoryMap;
        if(!current_category) return;
        const current_categoryIds = Object.keys(current_category)
        let data = []
        for(let category_id of current_categoryIds){
          const category = current_category[category_id];
          if(category.checked)
            data.push({
              category_id:category.category_id,
              category_name:category.category_name,
              cate_path:category.cate_path,
              full_name:category.cate_name.join(' > '),
            })
          else{
            const children = this.getAliPoolSelectCategory(category.children)
            data = data.concat(...children)
          }
        }
        return data
      } 


    //#endregion


    
  //#region  按钮
    findButton = (types) => {
        var findValue = this.state.findValue;
        var changeSearchNav = types == "goods" ? "找货源" : types == "factory" ? "找工厂" : "";
        this.setState({ changeSearchNav })
        if (findValue == types)
            return;

        $("#zhukeOfferSearchInputId").val("");

        var openUrl = "https://s.1688.com/erpoffer/offer_search.html?keywords=&charset=utf8&erp_app_key=8076003";
        if (types == "factory")
            openUrl = "https://s.1688.com/company/pc/erp_search.htm?keywords=&charset=utf8&erp_app_key=8076003";

        this.setState({
            findValue: types,
            openUrl: openUrl
        });

    }
    queryButton = () => {
        var values = $("#zhukeOfferSearchInputId").val();

        var findValue = this.state.findValue;
        var openUrl = "https://s.1688.com/erpoffer/offer_search.html?keywords=" + values + "&charset=utf8&erp_app_key=8076003";
        if (findValue == "factory")
            openUrl = "https://s.1688.com/company/pc/erp_search.htm?keywords=" + values + "&charset=utf8&erp_app_key=8076003";

        this.setState({
            openUrl: openUrl
        });
    }

    //#endregion

    //#region  获取店铺列表
    loadShopList() {
        var that = this;
        //开启动画
        requests({
            url: "/MyShop/List",
            data: {},
            success: function (res) {
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                    return;

                if (res.Success) {
                    var listData = res.Data.DataList.Shops;

                    that.setState({
                        shopList: listData
                    }, () => {
                        //that.resetData();
                    })

                } else {
                    messageShow("获取店铺列表错误：" + res.Message, 'error');
                }
            },
        });
    }

    //#endregion


     //#region 获取类目和标签
    //获取类目和标签
    loadCategoryTag = () => {
        if (this.state.isShowWarn)
            return;
        var that = this;
        //开启动画
        that.setState({ isLoading: true });
        requests({
            url: "/ShopCommon/GetChoicenessProductConfig",
            shopType: true,
            data: {},
            success: function (res) {

                that.setState({ isLoading: false }); //关闭动画
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                    return;

                if (res.Success) {
                    var categoryList = res.Data.Categorys;
                    
                    var tagList = res.Data.Rules;

                    for (let c = 0; c < categoryList.length; c++) {
                        categoryList[c].checked = false;
                    }
                    for (let t = 0; t < tagList.length; t++) {
                        tagList[t].checked = false;
                    }
                    that.setState({
                        categoryList: categoryList,
                        tagList: tagList
                    })

                    that.loadList(true);//加载列表
                } else {
                    messageShow("获取类目失败：" + res.Message, 'error');
                }
            },
        });
    }

    //#endregion
    
    //#region  精选货源列表
    //精选货源列表
    loadList = (first) => {

        var that = this;
        let obj = this.parameterjson();
        console.log("obj==",obj)
        // if (this.state.isShowWarn) {
        //     Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
        //     return;
        // }
        //开启动画

        if (this.state.selectPlatformNav == "tthy") {
            this.loadTaoteProductList();
        }
        else if (this.state.selectPlatformNav == "bdyhy") {
            this.loadBdyProductList();
        }else if (this.state.selectPlatformNav == "fxhy") {
            this.loadFenXiaoProductList();
        }
        else {
            that.setState({ isLoading: true });
            var url = "/Product/QueryChoicenessSource";
            var shopType = false;
            if (this.state.isShowWarn === true || first) {
                shopType = true;
                url = "/ShopCommon/QueryChoicenessSource";
            }
            requests({
                url: url,
                data: obj,
                shopType: shopType,
                success: function (res) {
                    that.setState({ isLoading: false }); //关闭动画
                    if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                        return;

                    if (res.Success) {
                        var productList = res.Data.List;
                        var totals = res.Data.TotalCount;
                        for (let t = 0; t < productList.length; t++) {
                            productList[t].checked = false;
                            productList[t].ServiceList = [];

                            try {
                                var serviceListJson = productList[t].ServiceListJson;
                                if (serviceListJson != "" && serviceListJson != null && serviceListJson != undefined)
                                    productList[t].ServiceList = JSON.parse(serviceListJson);
                            } catch (error) { }
                        }

                        that.loadJxhyDetail(productList,obj.SupportEncryptChannel)
                        var pagesize = that.state.pagesize;
                        var current = that.state.current;
                        that.setState({
                            productList: productList,
                            totals: totals,
                            isShowNextCurrent: !(pagesize * current >= totals)
                        })

                        $("#allCheck_id_Below").prop("checked", false);//全选按钮重置


                    } else {
                        messageShow("获取精选货源列表失败：" + res.Message, 'error');
                    }
                },
            });
        }
    }
    parameterjson = () => {
       
        var data = {};

        data.PageIndex = this.state.current;
        data.PageSize = this.state.pagesize;
        data.Keyword = $("#productTitleId").val();
        data.IsSupportEncryptCreateOrderSupplier = this.state.isSupportEncryptCreateOrderSupplier;
       
        const {selectCategoryId} = this.state
        var categoryList = this.state.categoryList;
        var categoryId = 0;
        categoryList.forEach(t => {
            if (t.checked)
                categoryId = t.Id;
        });
        if (categoryId != 0)
            data.CategoryId = categoryId;
        if (selectCategoryId != 0) {
            data.CategoryId = selectCategoryId
        }
        const selectCategorys = this.getSelectCategory();
        if(selectCategorys && selectCategorys.length > 0){
            const selectCategory = selectCategorys[selectCategorys.length - 1];
            data.CategoryId = selectCategory.category_id;
        }
       

        var tagList = this.state.tagList;
        var tagId = 0;
        tagList.forEach(t => {
            if (t.checked)
                tagId = t.RuleId;
        });
        if (tagId != 0)
            data.RuleId = tagId;

        if (this.state.orderby != "") {
            data.OrderBy = this.state.orderby;
            data.Sort = this.state.sort;
        }
        var selectEncrypt = this.state.searchSelectPatform.find(x => x.isActive);
        if(selectEncrypt){
            var channel = selectEncrypt.value;
            data.SupportEncryptChannel = channel;
        }
        data.Filters = [];
        
        for(const filter of this.state.jxhyParames.filters){
            if(filter.checked) data.Filters.push(filter.key)
        }
        for(const filter of this.state.jxhyParames.filtersRate24H){
            if(filter.checked) data.Filters.push(filter.key)
        }
        for(const filter of this.state.jxhyParames.filtersRate48H){
            if(filter.checked) data.Filters.push(filter.key)
        }
        for(const filter of this.state.jxhyParames.filtersShip){
            if(filter.checked) data.Filters.push(filter.key)
        }

        return data;
    }
     //#endregion



    //#region  操作

    //类目的选择
    categoryChange = (e, id, isChecked,category) => {
        this.setFullChecked(this.state.categoryMap,false);
        var categoryList = this.state.categoryList;
        
        categoryList.forEach(t => {
            if (id == t.Id ) {
                t.checked = !isChecked;
            } else if (!isChecked)
                t.checked = false;
        })
        console.log("categoryList==",category)
        this.setState({
            categoryList: categoryList,
            current: 1,
            selectProductNumber: 0,
        }, () => {
            this.loadList()
        })

    }
    //类目的选择
    categorySelect = (e, id, isChecked,category) => {
        // const {categoryMap,isCategory} = this.state;
        
        // this.setFullChecked(this.state.categoryMap,false);
        // // this.setFullCategory(id,category)
        // console.log(categoryMap)
        
        // category.checked = isChecked
        
        // var categoryList = this.state.categoryList;
        // Object.values(categoryMap).forEach((item,i) => {
        //     if (item.category_id == isCategory.category_id) {
                
        //         console.log(item)
        //         item = isCategory
        //     }
        // })
        
        // const newCategoryMap = Object.keys(_categoryMap);

        // console.log("newCategoryMap===",categoryMap)
        this.setState({
            // categoryList: categoryList,
            // categoryMap:categoryMap
            selectCategoryId: id
        }, () => {
            this.loadList()
        })

    }
   
    //类目的选择
    aliPoolCategorySelect = (e, id, isChecked,category) => {
        this.setState({
            selectAliPoolCategoryId: id
        }, () => {
            this.loadList()
        })

    }

     //类目的选择


    //标签选择
    changeTag = (e, id, isChecked) => {
        var tagList = this.state.tagList;
        tagList.forEach(t => {
            if (id == t.RuleId) {
                t.checked = !isChecked;
            } else if (!isChecked)
                t.checked = false;
        })
        this.setState({
            tagList: tagList,
            current: 1,
            selectProductNumber: 0
        }, () => {
            this.loadList()
        })
    }

    //选择的排序
    orderbyChange = (e, orderby) => {
        let sortNav = this.state.sortNav;
        var sort = "0";
        sortNav.forEach((item, index) => {
            // let isSelect = item.IsSelect;          
            if (item.Title == orderby) {
                item.childSort = !item.childSort
                item.IsSelect = true;

                if (item.childSort == true)
                    sort = "0";
                else
                    sort = "1";

            } else {
                item.IsSelect = false;
            }
        })
        this.setState({ orderby: orderby, sort: sort, sortNav }, () => {
            this.loadList();
        });
    }


    //改变页码
    changePageCurrent(current) {
        this.setState({ current: current, selectProductNumber: 0 }, () => {
            this.loadList()
        })

    }
    changeNextPageCurrent() {
        let current = this.state.current + 1;
        this.setState({
            current
        }, () => {
            this.loadList();
        })
    }

    //改变 一页多少条
    changePageSize(pagesize) {
        this.setState({ pagesize: pagesize, current: 1 }, () => {
            this.loadList()
        })
    }

    //选择店铺
    shopChange = (Id) => {
        var check = $("#checkboxShop_" + Id).prop("checked");

        var shopList = this.state.shopList;
        for (var i = 0; i < shopList.length; i++) {
            if (shopList[i].Id == Id) {
                if (check == true && (isNotNull(shopList[i].PayUrl) || isNotNull(shopList[i].AuthUrl))) {
                    $("#checkboxShop_" + Id).prop("checked", false);//上面的按钮点击
                    messageShow("店铺授权失效，不能勾选！", 'info');
                } else
                    shopList[i].IsChecked = !shopList[i].IsChecked;
                break;
            }
        }
        this.setState({
            shopList
        })
    }

     //获取时间间隔(以天为单位)
     getTimespanDay = (date) => {
        var diff = Date.parse(date) - new Date();
        return diff / (1000 * 60 * 60 * 24);
    }
    //选择平台确定的弹窗确认按钮
    sureChoosePlatform = () => {
        //console.log("selectPlatform",this.state.selectPlatform)
        this.setState({
            isShowChoosePlatform: false,
            isShowAddShop: true
        })
    }

      /**淘特授权过期跳转对话框 */
      alibabaAuthDailog(that) {
        MessageBox.msgbox({
            title: '授权提示',
            message: <span>当前操作需要获得<span style={{ color: "#fa1f07", "fontSize": "16px" }}>1688货源授权</span>，您未获得1688授权或者授权失效，请先进行授权</span>,
            type: 'info',
            showCancelButton: false,
            confirmButtonText: '去授权'
        }).then((action) => {
            if (action == 'confirm') {
                const path = { pathname: '/myAuth', state: { from_action: "alibaba_auth_expire" } }
                that.props.history.push(path);
            }
        })
    }

    //全部，选择商品事件
    allCheckbox(types) {
        var productList = this.state.productList;
        var selectNumber = 0;
        var isCheck = false;

        if (types == "above")
            isCheck = $("#allCheck_id_Above").prop("checked");//上面的按钮
        else
            isCheck = $("#allCheck_id_Below").prop("checked");//下面的按钮

        for (let i = 0; i < productList.length; i++) {
            productList[i].checked = isCheck;

            if (productList[i].checked)
                selectNumber++;
        }

        this.setState({
            productList: productList,
            selectProductNumber: selectNumber
        })

    }

    pricePopoverClick(dto) {
        if (dto.MaxPrice && dto.MinPrice) {
            const maxPrice = parseFloat(dto.MaxPrice)
            const minPrice = parseFloat(dto.MinPrice)
            if (maxPrice < minPrice) {
                messageShow('最高价必须大于最低价', 'error')
                dto.MinPrice = ''
                dto.MaxPrice = ''
                this.setState({})
                return
            }
        }
        // this.state.fenxiaoProductParame.priceChecked = false;
        document.getElementById('root').click()
        this.loadList();
    }
    
    closeBanner = () => {
        this.setState({
            isSowBanner: false
        }, () => {
            var obj = {};
            obj.isShowBanner = false;
            localStorage.setItem('isShowBannerObj', JSON.stringify(obj));
        })

    }
    showMySelect = (e) => {
        e.nativeEvent.stopImmediatePropagation();
        this.setState({
            // ciphertextOrderSetDailog:getStorage("ciphertextOrderSetDailog")!=1,
            isShowMySelect: true
        })
    }
    chooseSearchtPatform = (id) => {
        let searchSelectPatform = this.state.searchSelectPatform;
        searchSelectPatform.forEach((item, index) => {
            if (id == item.Id) {
                item.isActive = !item.isActive
            } else {
                item.isActive = false;
            }
        })
        this.setState({ searchSelectPatform })
        this.state.current = 1;
        this.loadList()
    }
    chooseAliPoolSearchtPatform = (id) => {
        let searchAliPoolSelectPatform = this.state.searchAliPoolSelectPatform;
        searchAliPoolSelectPatform.forEach((item, index) => {
            if (id == item.Id) {
                item.isActive = !item.isActive
            } else {
                item.isActive = false;
            }
        })
        this.setState({ searchAliPoolSelectPatform })
        this.state.current = 1;
        this.loadList()
    }

    cancelCiphertextOrderModul=()=>{
        setStorage("ciphertextOrderSetDailog",1)
        this.setState({
            ciphertextOrderSetDailog:false
        })
    }
    async saveOrderConfig()
    {
        const isAutoEncryptMark = $("input[name=ciphertextOrderSet]:checked").val()
        if(isAutoEncryptMark){
            let data = { IsAutoEncryptMarke:isAutoEncryptMark }
            const res = await SaveOrderConfigRequest(data);
        }
        this.cancelCiphertextOrderModul();
    }


    //关联已有店铺商品
    relevanceShopProduct = () => {
        var obj = {};
        obj.offerId = this.state.offerIdList[0]
        var path = {
            pathname: "shopProduct",
            state: obj
        }
        if (this.state.selectPlatformNav == 'jxhy')
            obj.productTag = 'pifatuan';
        this.props.history.push(path);
    }

    /*通用设置字段方法*/
    setFieldData(dto, name, value) {
        dto[name] = value;
        this.setState({});
    }
    /**重置所有数据 */
    resetField(dto, name, ...arr) {
        dto[name] = '';
        arr.forEach(x => x.checked = false);
        this.setState({}, () => { console.log(this.state.queryTaoteProductDto); this.loadTaoteProductList() });
    }
    /**设置单选功能*/
    setSingleFieldCheckData(arr, item, dto, name, value, callback) {
        const checked = !item.checked;
        arr.forEach(x => x.checked = false);
        item.checked = checked;
        if (checked)
            dto[name] = value
        else
            dto[name] = ''
        const that = this;
        this.setState({}, () => { console.log(this.state.queryTaoteProductDto); if (callback) callback(that) });
    }


    //#endregion


    //#region 开始铺货

    //单个铺货
    onePuHuo = (id, item) => {
        //this.resetData();//重置选择

        this.setState({
            offerIdList: [item],
            isShowPuHuo: true
        }, () => {
            //this.distributionPreposition();
        })
    }

    //开始铺货,铺货前的类目匹配
    distributionPreposition = () => {
        if (this.state.selectPlatformNav == 'jxhy' && this.state.isShowWarn === true) {
            this.alibabaAuthDailog(this);
            return;
        }

        var selectShopList = [];
        var selectShopListBySupplier = [];
        var shoplist = this.state.shopList;
        for (let i = 0; i < shoplist.length; i++) {
            if (shoplist[i].IsChecked == true) {
                selectShopList.push(shoplist[i].Id);

                selectShopListBySupplier.push({
                    ShopId: shoplist[i].Id,
                    ShopName: shoplist[i].ShopName,
                    PlatformType: shoplist[i].PlatformType,
                    CategoryNameShowText: "",
                    TargetCates: [],
                    IsLoadIng: true,
                    IsButtonRed: false,
                });
            }
        }
        // if(this.state.selectShopId)
        // {
        //     selectShopList.push(this.state.selectShopId);
        //     selectShopListBySupplier.push({
        //         ShopId: this.state.selectShopId,
        //             ShopName: this.state.selectShopName,
        //             PlatformType: this.state.selectplatformType,
        //             CategoryNameShowText: "",
        //             TargetCates: [],
        //             IsLoadIng: true,
        //             IsButtonRed: false,
        //     })
        // }


        if (selectShopList == null || selectShopList == undefined || (selectShopList != null && selectShopList.length == 0)) {
            messageShow("请选择店铺！", 'info');
            return;
        }


        var supplierProductList = [];
        var offerIdList = this.state.offerIdList;
        for (let i = 0; i < offerIdList.length; i++) {
            supplierProductList.push({
                SupplierLoginId: '',
                SupplierProductId: offerIdList[i].ProductId,
                SupplierMemberId: '',
                SourcePlatform: offerIdList[i].SourcePlatform,
            })
        }

        if (supplierProductList.length == 0) {
            messageShow("请选择商品！", 'info');
            return;
        }
        const alibabaSupplierProducts = supplierProductList.filter(x => x.SourcePlatform == 'AlibabaZhuKe'
            || !x.SourcePlatform);
        const taoteSupplierProducts = supplierProductList.filter(x => x.SourcePlatform == 'TaoteZhuKe');
        if (alibabaSupplierProducts.length > 0 && !systemConfig.zhukeAlibabaAuth) {
            this.alibabaAuthDailog(this);
            return;
        }
        if (taoteSupplierProducts.length > 0 && !systemConfig.zhukeTaoteAuth) {
            this.taoteAuthExpireDailog(this);
            return;
        }

        var data = {
            TargetShopIds: selectShopList,
            SupplierProductList: supplierProductList,
            UniqueKey: "",
        }
        if (this.state.selectPlatformNav == 'jxhy')
            data.ProductTag = 'pifatuan';


        this.setState({ isLoading: true, isShowChooseShopModul: false, loadingTitle: '获取商品中...', affirmByeBatchDistributionByData: data })

        var that = this;

        let reqUrl = '/BatchDistribution/VerificationCategoryV2';
        // if (systemConfig.isZk5()) {
        //     reqUrl = '/BatchDistribution/VerificationCategoryV2';
        // }
        requests({
            url: reqUrl,
            data: data,
            success: function (res) {
                //关闭动画
                that.setState({ isLoading: false });
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                    return;


                if (res.Success) {
                    var listSupplierProduct = res.Data.SupplierProducts;
                    if (listSupplierProduct == null || listSupplierProduct == undefined)
                        listSupplierProduct = [];

                    for (let i = 0; i < listSupplierProduct.length; i++) {
                        listSupplierProduct[i].ShopDataList = selectShopListBySupplier;
                    }

                    var state = {};
                    var faildList = [];
                    var successList = [];

                    supplierProductList.forEach(s => {
                        var index = listSupplierProduct.findIndex(m => m.ProductId == s.SupplierProductId);
                        if (index == -1) {
                            faildList.push(s);
                        } else {
                            successList.push(s)
                        }
                    })

                    if (successList.length == 0) {
                        messageShow("当前选择的货源，获取不到商品！", 'error');
                        return;
                    }

                    if (successList.length > 0 && faildList.length > 0)
                        messageShow("有" + faildList.length + "个商品获取不到，已过滤显示！", 'warning');


                    state.supplierProductListByBatch = listSupplierProduct;
                    state.isShowByDistributionSelectCategory = true;
                    state.isShowPuHuo = false;

                    that.setState(state, () => {
                        that.getCategoryBySupplierOne();
                    })



                } else {
                    if (res.ErrorCode == "SHOP_EXPIRED") {
                        messageShow("选择的店铺包含授权过期，请选择重新店铺！", 'error');
                        //that.loadShopList();//获取店铺列表
                    }
                    else if (res.ErrorCode == "ReachListingCount") {
                        // that.setState({ isShowReachListingCount: true });

                        // that.loadUpgradeAppPayInfo();
                        MessageBox.confirm(<div>
                            <div>
                                根据1688货源分销规则，使用1688免费版【铺货代发】
                                授权货源最多只能铺货5次。订购1688【<a className='defColor' href='https://pc.1688.com/product/detail.htm?spm=a26370.isv_inner_8076003.0.0.5200YeNJYeNJRU&productCode=FLjfKOZUVVsdPaSNpobsgo5MSv%2BCKZ62omVo8x4qfKc%3D&productType=GROUP&mkey=k_12039404' target={'_blank'}>铺货代发</a>】高级版授权，不限铺货次数。
                            </div>
                            <div style={{ "marginTop": "16px" }}>
                                特别说明:免费版、高级版指1688货源端【铺货代发】
                            </div>
                        </div>, '提示', {
                            customClass: 'home_reach_listing_count_dailog',
                            confirmButtonText: "订购高级版"
                        }).then(() => {
                            window.open('https://pc.1688.com/product/detail.htm?spm=a26370.isv_inner_8076003.0.0.5200YeNJYeNJRU&productCode=FLjfKOZUVVsdPaSNpobsgo5MSv%2BCKZ62omVo8x4qfKc%3D&productType=GROUP&mkey=k_12039404');
                        });
                    }else if(res.ErrorCode="COMMON_ERROR")
                    {
                        messageShow(res.Message, 'error');
                    }    
                    else if (res.ErrorCode == "NOT_FREIGHT_TEMPLATE") {
                        that.setState({
                            isShowNotFreightTemplate: true,
                            notFreightTemplateValue: res.Message
                        });
                    } else {
                        // if (that.state.fromMenu == true) {
                        //     that.setState({
                        //         fenxiaojiaoChengDialog: true,
                        //         fenxiaoProductFaildList: that.state.supplierProductIds,
                        //         supplierProductIds: [],
                        //         offerIdList: [],
                        //     });
                        // }
                        // else {

                        if (res.Message.indexOf("商品信息获取失败") != -1)
                            messageShow("商品信息获取失败", 'warning');

                        else
                            messageShow("铺货前匹配类目失败:" + res.Message, 'error');
                        //}
                    }
                }

            },
        });
    }

    //铺货超过5次，弹窗升级
    loadUpgradeAppPayInfo() {
        var that = this;
        requests({
            url: "/Common/LoadUpgradeAppPayInfo",
            data: { SystemVersions: 'pc' },
            success: function (res) {
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                    return;

                if (res.Success) {
                    try {
                        var versionsDistinction = [];
                        var functionDistinction = [];
                        var payUserList = [];
                        var upgradeUrl = "";
                        var lingQuUpgradeUrl = "";
                        if (res.Data.VersionsDistinction != "")
                            versionsDistinction = JSON.parse(res.Data.VersionsDistinction);
                        if (res.Data.FunctionDistinction != "")
                            functionDistinction = JSON.parse(res.Data.FunctionDistinction);

                        if (res.Data.PayList != null)
                            payUserList = res.Data.PayList;

                        if (res.Data.UpgradeDistinctionByUrl != "") {
                            var UpgradeDistinctionByUrl = JSON.parse(res.Data.UpgradeDistinctionByUrl);
                            upgradeUrl = UpgradeDistinctionByUrl.UpgradeUrl;
                            lingQuUpgradeUrl = UpgradeDistinctionByUrl.LingQuUpgradeUrl;
                        }

                        var PayInfoList = versionsDistinction[that.state.PayIndex].PayInfoList ? versionsDistinction[that.state.PayIndex].PayInfoList : [];
                        that.setState({
                            versionsDistinction: versionsDistinction,
                            functionDistinction: functionDistinction,
                            payUserList: payUserList,
                            upgradeUrl: upgradeUrl,//升级链接
                            lingQuUpgradeUrl: lingQuUpgradeUrl,// 领劵升级
                            isShowReachListingCount: true,
                            PayInfoList
                        }, () => {
                            that.xufeiShopsShow();
                        });

                        // console.log("versionsDistinction", versionsDistinction)
                        // console.log("functionDistinction", functionDistinction)

                    } catch (e) {

                    }

                } else {

                }
            },
        });
    }



    
    batchPuHuo = () => {

        //var shopList = this.state.shopList;
        // if (shopList.length == 0) {
        //     this.addShop();
        //     return;
        // }
        var productList = this.state.productList;
        var selecrNumber = 0;
        var offerIdList = [];
        for (let i = 0; i < productList.length; i++) {
            if (productList[i].checked) {
                selecrNumber++;
                offerIdList.push(productList[i]);
            }
        }

        if (selecrNumber == 0) {
            messageShow("请选择货源", 'info');
            return;
        }

        //this.resetData();//重置选择

        this.setState({
            offerIdList: offerIdList,
            isShowPuHuo: true,
        }, () => {
            //this.distributionPreposition();
        })

    }

    

    //铺货前，获取供应商商品后，开始轮训类目
    async getCategoryBySupplierOne() {
        var productList = this.state.supplierProductListByBatch;
        var lunxunList = [];
        for (let i = 0; i < productList.length; i++) {
            var shopL = productList[i].ShopDataList;
            var shopIdL = [];
            for (let j = 0; j < shopL.length; j++) {
                shopIdL.push(shopL[j].ShopId);
            }

            lunxunList.push({
                TargetShopIds: shopIdL,
                SourceProductId: productList[i].ProductId,
                SourcePlatform: productList[i].PlatformType,
                SourceCateId: productList[i].CategoryId,
                SourceCateName: productList[i].CategoryName,
                ProductTitle: productList[i].Subject,
                UseCustom: true,
            })
        }

        //任务发出去，按商品的维度
        for (var i = lunxunList.length - 1; i >= 0; i--) {
            await this.lunxunByShopCategory(lunxunList[i]);
        }
    }

    //按商品的维度，把每个任务分发出去
    lunxunByShopCategory = (dates) => {
        var data = dates;
        var that = this;
        return new Promise((resolve, reject) => {
            requests({
                url: "/BatchDistribution/GetMatchingCategory",
                data: data,
                success: function (res) {
                    if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                    {
                        that.lunxunDataResult(dates, []);
                        resolve(0);
                        return;
                    }

                    if (res.Success) {
                        //成功后，把类目的赋值上
                        var resList = res.Data.MatchingShops;
                        if (resList == null || resList == undefined)
                            resList = [];

                        //console.log("resList:" + JSON.stringify(resList));
                        that.lunxunDataResult(dates, resList);
                        resolve(1);
                    } else {
                        that.lunxunDataResult(dates, []);
                        reject(res.Message)
                    }
                },
            });
        })
    }

    lunxunDataResult = (dates, resList) => {
        var productList = this.state.supplierProductListByBatch;
        for (let i = 0; i < productList.length; i++) {
            if (dates.SourceProductId == productList[i].ProductId) {
                var shopL = JSON.parse(JSON.stringify(productList[i].ShopDataList));
                for (let j = 0; j < shopL.length; j++) {
                    var targetCatesList = [];
                    for (let k = 0; k < resList.length; k++) {
                        if (resList[k].TargetShopId == shopL[j].ShopId) {
                            if (resList[k].TargetCates == null || resList[k].TargetCates == undefined)
                                targetCatesList = [];
                            else
                                targetCatesList = resList[k].TargetCates;

                            break;
                        }
                    }

                    var textValue = "";
                    if (targetCatesList.length > 0) {
                        targetCatesList.forEach((cc) => {
                            textValue += cc.Name + '—';
                        })
                    }

                    shopL[j].TargetCates = targetCatesList;
                    shopL[j].CategoryNameShowText = textValue.substr(0, textValue.length - 1);
                    shopL[j].IsLoadIng = false;
                }
                productList[i].ShopDataList = shopL;
                break;
            }
            //productList[i]=dates;
        }
        this.setState({ supplierProductListByBatch: productList });

    }
    //立即铺货
    affirmByeBatchDistribution = () => {
        var productList = this.state.supplierProductListByBatch;
        var isNotSelect = false;
        for (let i = 0; i < productList.length; i++) {
            var shopL = JSON.parse(JSON.stringify(productList[i].ShopDataList));
            for (let j = 0; j < shopL.length; j++) {
                if (shopL[j].TargetCates.length == 0) {
                    shopL[j].IsButtonRed = true;
                    isNotSelect = true;
                }
            }
            productList[i].ShopDataList = shopL;
        }

        if (isNotSelect) {
            this.setState({ supplierProductListByBatch: productList });
            messageShow("请选择商品类目", 'info');
            return;
        }

        var data = this.state.affirmByeBatchDistributionByData;
        data.Features = {}
        
        data.Features.BatchListingFeaturesList = productList.flatMap(x => x.ShopDataList.map(s => { return {
            CatePathList : s.TargetCates.map(o => { return { CateId:o.Id,CateName:o.Name  }}),
            ShopId:s.ShopId,
            SupplierProductId : x.ProductId,
            SourcePlatform : x.PlatformType
        }}))

        var allNum = data.TargetShopIds.length * this.state.offerIdList.length; //不用data.SupplierProductList这个，是因为有uniqueKey 的时候，会置空

        //目前不按云平台，统一铺货。
        this.setState({ isLoading: true, isShowChooseShopModul: false, loadingTitle: '正在铺货中...' })

        let reqUrl = "/BatchDistribution/BatchListingMobileByProductIdListV2";
        // if (systemConfig.isZk5()) {
        //     reqUrl = "/BatchDistribution/BatchListingMobileByProductIdListV2";
        // }
        var that = this;
        requests({
            url: reqUrl,
            data: data,
            success: function (res) {
                //关闭动画

                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                {
                    that.setState({ isLoading: false })
                    return;
                }
                var taskCodeRes = that.state.taskCodeRes;   //:{taskCode:'',isPost:false,successNumber:0,errorNumber:0,errorList:[]}
                if (res.Success) {
                    taskCodeRes.taskCode = res.Data;
                    taskCodeRes.isPost = true;
                    taskCodeRes.allNumber = allNum;

                    that.setState({ taskCodeRes: taskCodeRes });

                    setTimeout(() => {
                        //只负责把任务赋值上。不做轮训，轮训交由检查接口那里做
                        that.sureBatchDistributionPostTaskCode();
                    }, 1000);
                } else {
                    that.setState({ isLoading: false });
                    //已超过免费的铺货数量
                    if (res.ErrorCode == "ReachListingCount")
                        that.setState({ isShowReachListingCount: true });
                    else {
                        var errResList = [];
                        errResList.push("(1)" + res.Message);

                        that.sureBatchDistributionPostRes(taskCodeRes.allNumber, errResList.length, errResList);
                    }

                }
            },
        });

    }

    //轮巡  铺货任务的处理。
    sureBatchDistributionPostTaskCode = () => {
        var taskCodeRes = this.state.taskCodeRes;

        var that = this;
        requests({
            url: "/Common/GetZhuKeReqTask",
            data: { TaskCode: taskCodeRes.taskCode },
            success: function (res) {

                //关闭动画
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                {
                    taskCodeRes.isPost = false;
                    taskCodeRes.taskCode = '';
                    that.setState({ isLoading: false, loadingTitle: '加载日志...', taskCodeRes: taskCodeRes })
                    return false;
                }


                if (res.Success) {
                    var dates = res.Data;
                    if (dates.FinishedTime != null && dates.FinishedTime != "" && dates.FinishedTime != undefined) {
                        that.setState({ isLoading: false });

                        if (dates.Status == "Error") {
                            var errResList = [];

                            let errMessage = dates.ErrorMsg;
                            if (!errMessage) {
                                errMessage = '创建任务失败';
                            }
                            errResList.push("(3)" + errMessage);

                            that.sureBatchDistributionPostRes(0, taskCodeRes.allNumber, errResList);
                        } else {

                            var rspContentJson = JSON.parse(dates.RspContent);
                            var errorList = rspContentJson == null || (rspContentJson != null && rspContentJson.ErrorList == null) ? [] : rspContentJson.ErrorList;

                            that.sureBatchDistributionPostRes(taskCodeRes.allNumber - errorList.length, errorList.length, errorList);

                        }
                    } else {

                        setTimeout(() => {
                            that.sureBatchDistributionPostTaskCode();
                        }, 1000);
                    }
                } else {
                    var errResList = [];
                    errResList.push("(2)" + res.Message);

                    that.sureBatchDistributionPostRes(0, taskCodeRes.allNumber, errResList);

                }
            },
        });

    }

    //铺货任务 结果
    sureBatchDistributionPostRes = (successNumber, errorNumber, errorList) => {

        var taskCodeRes = this.state.taskCodeRes;

        taskCodeRes.isPost = false;

        taskCodeRes.successNumber = successNumber;
        taskCodeRes.errorNumber = errorNumber;
        taskCodeRes.errorList = errorList;
        taskCodeRes.taskCode = '';

        this.setState({ isShowTaskCodeRes: true, taskCodeRes: taskCodeRes, isShowByDistributionSelectCategory: false });


    }
    
    showPreviewDistributionList= async ()=>{
        let productList = this.state.productList;
        let selecrNumber = 0;
        let selectPreviewProductList=[];
        for (let i = 0; i < productList.length; i++) {
            if (productList[i].checked) {
                selecrNumber++;
                selectPreviewProductList.push(productList[i]);
            }
        }
        if(selectPreviewProductList.length == 0){
            messageShow('请选择商品！','info');
            return
        }
        if(selectPreviewProductList.length > 10){
            messageShow('最多选择十个预览铺货','info');
            return
        }
        if (this.state.selectPlatformNav == 'jxhy' && this.state.isShowWarn === true) {
            this.alibabaAuthDailog(this);
            return;
        }

        this.setState({
            selectPreviewProductList,
            showPreviewDistributionDailog: true,
        })

    }
    previewSureBatchPuhuo= async(listingProducts)=>{
        this.state.showPreviewDistributionDailog = false
        console.log('listingProducts =>',listingProducts)
        let supplierProductList = listingProducts.map(x => { return { 
            SupplierProductId : x.supplierProduct.ProductId,
            SourcePlatform : x.supplierProduct.PlatformType
        }})
        const data = {
            TargetShopIds:[getLoginShopInfo().loginShopId],
            SupplierProductList:supplierProductList,
            ProductTag :'',
            Features : {}
        }
        data.Features.BatchListingFeaturesList = listingProducts.map(x => {
            return {
                CatePathList : x.catePathList,
                RelationCode : x.RelationCode,
                Title : x.supplierProduct.Subject,
                ShopId:getLoginShopInfo().loginShopId,
                SupplierProductId : x.supplierProduct.ProductId,
                SourcePlatform : x.supplierProduct.PlatformType
            }
        })
        if (this.state.selectPlatformNav == 'jxhy')
            data.ProductTag = 'pifatuan';
        var allNum = listingProducts.length; //不用data.SupplierProductList这个，是因为有uniqueKey 的时候，会置空

        //目前不按云平台，统一铺货。
        this.setState({ isLoading: true, isShowChooseShopModul: false, loadingTitle: '正在铺货中...' })
        const res = await BatchListingMobileByProductIdListV2Request(data)
        const taskCodeRes = this.state.taskCodeRes;   //:{taskCode:'',isPost:false,successNumber:0,errorNumber:0,errorList:[]}
        if (res.Success) {
            taskCodeRes.taskCode = res.Data;
            taskCodeRes.isPost = true;
            taskCodeRes.allNumber = allNum;

            this.setState({ taskCodeRes: taskCodeRes });

            setTimeout(() => {
                //只负责把任务赋值上。不做轮训，轮训交由检查接口那里做
                this.sureBatchDistributionPostTaskCode();
            }, 1000);
        } else {
            this.setState({ isLoading: false })

            //已超过免费的铺货数量
            if (res.ErrorCode == "ReachListingCount")
                this.setState({ isShowReachListingCount: true });
            else {
                var errResList = [];
                errResList.push("(1)" + res.Message);
                this.sureBatchDistributionPostRes(taskCodeRes.allNumber, errResList.length, errResList);
            }
        }

    }
    cancelPreviewDistribution=()=>{
        this.setState({showPreviewDistributionDailog:false})

    }

    selectCheck = (item, checked) => {
        var productList = this.state.productList;
        var selectNumber = 0;
        var isAllChange = true;

        item.checked = !checked;
        for (let i = 0; i < productList.length; i++) {
            if (productList[i].checked)
                selectNumber++;
            else
                isAllChange = false;
        }

        $("#allCheck_id_Below").prop("checked", isAllChange);//下面的按钮点击，上面的全选跟着变化

        this.setState({
            productList: productList,
            selectProductNumber: selectNumber
        })

    }

    

    addShopButton = (shows) => {
        shows.hide();

        $("#myShopListIndexId").click();

    }
    //#endregion
    
    //#region  续费
    xufeiShopsShow = () => {
        var xufeiShops = this.state.payUserList;
        var html = '';
        for (var i = 0; i < xufeiShops.length; i++) {
            html += '<li className="xufeiItems-item">';
            html += '<div className="xufeiItems-item-left">';
            html += '<span className="xufeiItems-item-icon"></span>';
            html += '<span className="xufeiItems-item-name">' + xufeiShops[i] + '</span>';
            html += '</div>';
            html += '<a className="xufeiItems-item-right" href="' + this.state.lingQuUpgradeUrl + '" target="_blank">领券升级</a>';
            html += '</li>';
        }
        $("#xufeiItems").html(html);
        //无缝滚动效果实现
        var oDiv = document.getElementById("xufeiContent");
        var oUl = document.getElementById("xufeiItems");
        oUl.innerHTML = oUl.innerHTML + oUl.innerHTML;
        var timer = setInterval(ulMove, 20);
        oDiv.onmouseover = function () {
            clearInterval(timer);
        }
        oDiv.onmouseout = function () {
            timer = setInterval(ulMove, 20);
        }
        function ulMove() {
            var oldP = (oUl.offsetHeight - 1) / 2;
            var newP = parseFloat(getComputedStyle(oUl).top) - 0.7;
            oUl.style.top = newP <= -oldP ? 0 : newP + "px";
        }
    }
    //#endregion
    
    changeNav = (name) => {
        this.props.history.replace(name)
    }
    //精选货源搜索
    searchProduct = () => {
        this.setState({ current: 1, selectProductNumber: 0 }, () => {
            this.loadList()
        })
    }

    //#region 铺货前，匹配类目
  



    //编辑类目
    editMapping = (productId, Id, platformType) => {

        this.setState({
            selectCategoryByProductId: productId,
            selectCategoryByShopId: Id,
            selectCategoryByPlatform: platformType,
            showSelectCategoryModule: true,
        });
    }

    //组件传回
    selectCategory = (cateList, selecCatetTitle) => {
        this.setState({ showSelectCategoryModule: false });

        var textValue = "";
        if (cateList != null && cateList != undefined && cateList != null) {
            if (cateList.length > 0) {
                for (let i = 0; i < cateList.length; i++) {
                    textValue += cateList[i].Name + '—';
                }
            }
        }

        var supplierCateId = 0;
        var supplierCateName = "";
        var sourcePlatform = "";
        var supplierProductListByBatch = this.state.supplierProductListByBatch;
        for (let i = 0; i < supplierProductListByBatch.length; i++) {
            if (supplierProductListByBatch[i].ProductId == this.state.selectCategoryByProductId) {
                var shopL = JSON.parse(JSON.stringify(supplierProductListByBatch[i].ShopDataList));
                for (let j = 0; j < supplierProductListByBatch[i].ShopDataList.length; j++) {
                    if (shopL[j].ShopId == this.state.selectCategoryByShopId) {
                        shopL[j].CategoryNameShowText = textValue.substr(0, textValue.length - 1);
                        shopL[j].TargetCates = cateList;
                        shopL[j].IsButtonRed = false;
                        supplierCateId = supplierProductListByBatch[i].CategoryId;
                        supplierCateName = supplierProductListByBatch[i].CategoryName;
                        sourcePlatform = supplierProductListByBatch[i].PlatformType;
                        break;
                    }
                }
                supplierProductListByBatch[i].ShopDataList = shopL;
            }
        }

        var datas = {
            SupplierCateId: supplierCateId,
            SupplierCateName: supplierCateName,
            SourcePlatform: sourcePlatform,
            TargetShopId: this.state.selectCategoryByShopId,
            TargetPlatform: this.state.selectCategoryByPlatform,
            TargetCateItems: cateList
        }


        //先隐藏，已实现，等选择类目组件做好后可以放开
        this.setState({ isLoading: true, loadingTitle: '保存类目...' })
        var that = this;
        requests({
            url: "/CateMapping/SaveCateMapping",
            data: datas,
            success: function (res) {
                that.setState({ isLoading: false })
                //关闭动画
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                    return false;

                if (res.Success) {
                    messageShow("保存类目成功", 'success');
                    that.setState({ supplierProductListByBatch: supplierProductListByBatch });
                    //that.conductIdenticalCate(datas);
                } else
                    messageShow(res.Message, 'error');

            },
        });
    }


    //重置数据
    resetData = () => {

        //重置店铺选择
        var shopList = this.state.shopList;
        for (let i = 0; i < shopList.length; i++) {
            shopList[i].IsChecked = false;
        }



        this.setState({ shopList: shopList });
    }


    gotoDistributionSet = () => {
        this.props.history.push('/distributionSet');
    }

    //铺货结果，跳转
    puhuoGotoLink = (id) => {
        this.setState({ isShowTaskCodeRes: false });
        $("#" + id).click();
    }



    //公共关闭
    cancelModul = (typeName) => {
        this.setState({
            [typeName]: false
        })
    }

    showFiltbarMoreOperate = () => {
        let isShowFiltbarMoreOperate = this.state.isShowFiltbarMoreOperate;
        this.setState({ isShowFiltbarMoreOperate: !isShowFiltbarMoreOperate })
    }
    // huoyuanLink = (item,addlog) => {
    //     var url = "https://detail.1688.com/offer/" + item.ProductId + ".html";

    //     if(addlog)
    //     {
    //         var op={
    //             OperatorType: 'click_1688jinxuan_product_shop',
    //             PlatformType :'',
    //             Description:item.ProductId ,
    //             Remark:'点击1688精选商品',
    //             SiteType:'PC',
    //         }
    //         AddSiteLogRequest(op)
    //     }

    //     if (item.SourcePlatform == 'TaoteZhuKe') {
    //         var url = 'https://market.m.taobao.com/app/nozomi/app-h5-detail/main/index.html?id=' + item.ProductId
    //     }
    //     window.open(url, "_blank");
    // }

    serviceEndTimeHtml = (serviceEndTime, payurl, authurl) => {
        if (!serviceEndTime)
            return null;
        if (payurl != "")//授权到期
            return;
        if (payurl == "" && authurl != "")
            return;

        const expire = parseInt(this.getTimespanDay(serviceEndTime));
        if (expire >= 7)
            return <span style={{ "color": "#aaa", "margin-top": "5px" }}>授权剩余时间: {expire}天</span>
        else if (expire < 1)
            return <span className='newerrorColor' style={{ "color": "#fe6f4f" }}>授权剩余时间不足一天</span>
        else if (expire < 7)
            return <span className='newerrorColor' style={{ "color": "#f29a1a" }}>授权剩余时间: {expire}天</span>
        return null;
    }

    //铺货设置 --跳转
    distributionSet = (shopid) => {
        var obj = {};
        obj.shopid = shopid;
        var path = {
            pathname: "distributionSet",
            state: obj
        }
        this.props.history.push(path);

        this.setState({ isShowPuHuo: false });
    }


    //添加弹框
    addShop = () => {
        var userFreeAndExceedLimit = $("#userFreeAndExceedLimit").html();
        if (userFreeAndExceedLimit == "true")
            this.setState({ isShowAddShopByUpgradeApp: true });
        else {
            this.setState({
                isShowChoosePlatform: true,
                selectPlatform: 'TouTiao',
            })
        }

    };

    //去订购和去授权，都合并到和添加店铺一样。
    authAndPay = (platform) => {
        this.setState({
            selectPlatform: platform,
            isShowAddShop: true,
        })
    }
    closeAddShopModal = () => {
        this.setState({
            isShowAddShop: false
        })
    }

    //返回软件内确认授权结果
    sureAuthShop = () => {
        let that = this;
        setTimeout(function () {
            that.setState({
                isShowAuthShop: true
            })
        }, 3000)
    }

    //授权点击后，弹窗提示的操作
    successAuthShop = () => {
        var that = this;
        that.setState({
            isLoading: true,//关闭加载
            isShowAuthShop: false,//关闭授权弹窗
            hasLoadBorder: true
        });
        requests({
            url: "/MyShop/AuthNewShop",
            data: {},
            success: function (res) {
                that.setState({ isLoading: false, hasLoadBorder: false }); //关闭动画
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                    return;

                if (res.Success) {
                    var shopid = res.Data.ShopId;
                    if (shopid != 0 && shopid != "") {
                        messageShow("授权成功", 'success');


                        setTimeout(() => {
                            //that.loadShopList();
                        }, 1500);
                    }
                    else
                        messageShow("未授权成功", 'info');

                } else
                    messageShow('error', "错误：" + res.Message, 'error');
            },
        });
    }

    //由子组件传回
    changeShops = (platforms, selectPlatform) => {
        this.setState({
            platforms: platforms,
            selectPlatform: selectPlatform
        });

    }
//#endregion


  //#region  切换货源

  changePlatformNav = (index) => {
    let platformNav = this.state.platformNav;
    let selectPlatformNav = "";
    platformNav.forEach((item, i) => {
        item.isSelect = false;
        if (index == i) {
            item.isSelect = true;
            selectPlatformNav = item.Name;
        }
    })
    this.state.current = 1;
    this.state.productList = []
    this.state.selectProductNumber = 0;
    this.state.totals = 0;

    this.state.orderby = ''
    this.state.sort = ''
    this.state.fenxiaoSortNav.forEach(s => { s.IsSelect = false, s.childSort = false })
    this.state.categoryList.forEach(s => { s.checked = false })
    //不清除，直接调用重置条件并查询，后续新增都是在重置那里。就不需要再写一套
    // this.state.queryFenXiaoProductDto.MinPrice = ''
    // this.state.queryFenXiaoProductDto.MaxPrice = ''
    // this.state.queryFenXiaoProductDto.Keyword = ''
    if (selectPlatformNav == 'fxhy') {
        var shopInfo = getLoginShopInfo();
        const op = {
            SiteType: 'pc',
            OperatorType: 'offerSearch_fenxiaoproduct',
            Remark: '货源中心-推荐货源',
            PlatformType: shopInfo.loginShopPlatformType,
            ShopId: shopInfo.loginShopId,
        }
        AddSiteLogRequest(op);
    }
    this.setState({ platformNav, selectPlatformNav }, () => {
        if (selectPlatformNav == 'jxhy' || selectPlatformNav == 'tthy'|| selectPlatformNav == 'bdyhy' || selectPlatformNav == 'fxhy') 
        {
            if (selectPlatformNav == 'tthy' && this.state.isShowWarn == true)//淘特货源，当前需要绑定店铺才能加载，这里判断下
            {
                //可以弹窗提示说明
            } 
            else if( selectPlatformNav == 'bdyhy')
                this.resetBdyParame();
            else if( selectPlatformNav == 'fxhy')
                this.resetFenxiaoParame();
            else
                this.loadList();
        }


         

    })

}
  //#endregion
   
    //设置精选货源查询参数
    resetJxhyFilterData(name,list){
        if(list && name == "checked"){
            list.forEach(x => x[name] = false)
        }
        this.setState({ },()=>{ this.loadList()});
    }
    setJxhyData(dto,name,value,list){

        if(list && name == 'checked'){
            list.forEach(x => x.checked = false);
        }
        dto[name] = value;
        this.state.current = 1;
        this.setState({ },()=>{ this.loadList()})
    }

    /*通用设置字段方法*/
    setFieldData(dto, name, value) {
        dto[name] = value;
        this.state.current = 1;
        this.setState({});
    }
    /**重置所有数据 */
    resetField(dto, name, ...arr) {
        dto[name] = '';
        arr.forEach(x => x.checked = false);
        this.setState({}, () => { console.log(this.state.queryTaoteProductDto); this.loadTaoteProductList() });
    }
    /**设置单选功能*/
    setSingleFieldCheckData(arr, item, dto, name, value, callback) {
        const checked = !item.checked;
        arr.forEach(x => x.checked = false);
        item.checked = checked;
        if (checked)
            dto[name] = value
        else
            dto[name] = ''
        const that = this;
        this.setState({}, () => { console.log(this.state.queryTaoteProductDto); if (callback) callback(that) });
    }

   //#region  淘特

    /**设置淘特商品池 */
    setTaoteProductPoolId(item) {
        this.state.current = 1;
        this.setSingleFieldCheckData(
            this.state.taoteProductParame.pools, item,
            this.state.queryTaoteProductDto.Feature, 'poolId', item.PoolId, this.loadTaoteProductList);
    }
    /**设置淘特类目 */
    setTaoteProductCategoryId(item) {
        this.state.current = 1;
        this.setSingleFieldCheckData(
            this.state.taoteProductParame.categorys, item,
            this.state.queryTaoteProductDto, 'CategoryId', item.Id, this.loadTaoteProductList);
    }
    /**设置淘特排序字段 */
    setTaoteProductOrderBy(item) {
        item.childSort = !item.childSort;
        this.state.current = 1;
        this.state.queryTaoteProductDto.Sort = item.childSort ? "1" : "0";
        this.state.taoteProductParame.orderBys.forEach(x => x.checked = false);
        this.state.queryTaoteProductDto.OrderBy = item.FieldId;
        item.checked = true;
        this.loadTaoteProductList();
    }
    setTaoteDefaultOrderBy() {
        this.state.current = 1;
        this.state.queryTaoteProductDto.Sort = "";
        this.state.taoteProductParame.orderBys.forEach(x => x.checked = false);
        this.state.queryTaoteProductDto.OrderBy = "";
        this.loadTaoteProductList();
    }
    /** 选择筛选特性 */
    selectTaoteFeatureOption(item) {
        this.state.current = 1;
        item.checked = !item.checked
        this.setState({})
    }
    /**设置淘特筛选功能 */
    setTaoteProductFeatureId(item, op) {
        this.state.current = 1;
        op.checked = !op.checked;
        this.state.queryTaoteProductDto.Feature[item.FeatureId] = item.Option.filter(x => x.checked).map(x => x.Item2).join(',');
        this.loadList();
    }
    /**设置价格 */
    setTaoteProductPrice(fieldId, value) {
        this.state.queryTaoteProductDto[fieldId] = value
        this.loadTaoteProductList();
    }
    /**加载淘特货源 */
    async loadTaoteProductList(that){
        if(this) that = this;
        if(that.state.isShowWarn){
            Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
            return;
        }
        that.setState({isLoading : true})
        that.state.queryTaoteProductDto.PageIndex = that.state.current;
        that.state.queryTaoteProductDto.PageSize = that.state.pagesize;
        const res = await QuerySupplierProductsRequest(that.state.queryTaoteProductDto);
        that.setState({isLoading : false})
        if(res.Success)
        {
			var pagesize = that.state.pagesize;
            var current = that.state.current;
            that.setState({
                isShowNextCurrent: !(pagesize * current >= res.Data.TotalCount)
            })
            that.state.productList = res.Data.Data;
            that.state.totals = res.Data.TotalCount;
            that.state.selectProductNumber = 0;
            $("#allCheck_id_Below").prop("checked", false);
            that.setState({ });
        }
        else if(res.ErrorCode == "TAOTE_AUTH_INVALID"){ that.taoteAuthExpireDailog(that);  }
        else { messageShow(res.Message,"error") }
    }
    /** 查询淘货源 */
    async loadTaoteProductParam(){
        if(this.state.isShowWarn)   
            return;
        const res = await TaoteProductParameRequest();
        if(res.Success){
            this.state.taoteProductParame.categorys = res.Data.Categorys
            this.state.taoteProductParame.features = res.Data.Features
            this.state.taoteProductParame.pools = res.Data.Pools
            this.state.taoteProductParame.orderBys = res.Data.OrderBys
            this.setState({})
        }
    }
    /** 重置淘特查询参数 */
    resetTaoteParame() {
        this.state.queryTaoteProductDto.Keyword = '';
        this.state.queryTaoteProductDto.OrderBy = '';
        this.state.queryTaoteProductDto.Sort = '';
        this.state.queryTaoteProductDto.MinPrice = '';
        this.state.queryTaoteProductDto.MaxPrice = '';
        this.state.queryTaoteProductDto.CategoryId = '';
        this.state.queryTaoteProductDto.Feature = {};
        this.state.current = 1;
        this.state.taoteProductParame.pools.forEach(x => { x.checked = false });
        this.state.taoteProductParame.categorys.forEach(x => { x.checked = false });
        this.state.taoteProductParame.features.forEach(x => { x.checked = false; x.Option.forEach(y => y.checked = false); });
        this.state.taoteProductParame.orderBys.forEach(x => { x.checked = false });
        this.state.taoteProductParame.priceChecked = false;
        this.loadTaoteProductList()
    }
    /**淘特授权过期跳转对话框 */
    taoteAuthExpireDailog(that) {
        MessageBox.msgbox({
            title: '授权提示',
            message: <span>当前操作需要获得<span style={{ color: "#fa1f07", "fontSize": "16px" }}>淘特货源授权</span>，您未获得淘特授权或者授权失效，请先进行授权</span>,
            type: 'info',
            showCancelButton: false,
            confirmButtonText: '去授权'
        }).then((action) => {
            if (action == 'confirm') {
                const path = { pathname: '/myAuth', state: { from_action: "taote_auth_expire" } }
                that.props.history.push(path);
            }
        })
    }

    //#endregion

  

    //#region  加载不打烊货源
     async loadBdyProductList() {
        if (this.state.isShowWarn) {
            Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
            return;
        }
        this.setState({ isLoading: true })
        this.state.queryBdyProductDto.PageIndex = this.state.current;
        this.state.queryBdyProductDto.PageSize = this.state.pagesize;

        this.state.queryBdyProductDto.OrderBy = this.state.orderby;
        this.state.queryBdyProductDto.Sort = this.state.sort;
        this.state.queryBdyProductDto.Filters=[];

        if(this.state.bdyBybtwlybt ==true)
           this.state.queryBdyProductDto.Filters.push("btwlybt");

        if(this.state.bdyByisJxhy ==true)
           this.state.queryBdyProductDto.Filters.push("IsJxhy");

        var selectEncrypt = this.state.searchAliPoolSelectPatform.find(x => x.isActive);
        if(selectEncrypt){
            var channel = selectEncrypt.value;
            this.state.queryBdyProductDto.SupportEncryptChannel = channel;
        }else
           this.state.queryBdyProductDto.SupportEncryptChannel = "";

        this.state.queryBdyProductDto.CategoryId=this.getAliPoolCategorySelectId();
        this.state.queryBdyProductDto.OfferPoolId=this.state.selectAliPoolId;
        console.log(JSON.stringify(this.state.queryBdyProductDto));

        //const res = await QueryFenXiaoProducts(this.state.queryBdyProductDto);
        const res = await QueryBdyProducts(this.state.queryBdyProductDto);
        this.setState({ isLoading: false })
        if (res.Success) {
            res.Data.List.forEach(item => {
                item.ServiceList = [];
                try {
                    var serviceListJson = item.ServiceListJson;
                    if (serviceListJson != "" && serviceListJson != null && serviceListJson != undefined)
                        item.ServiceList = JSON.parse(serviceListJson);
                } catch (error) { }
            })

            this.state.productList = res.Data.List;
            this.state.totals = res.Data.TotalCount;
            this.state.selectProductNumber = 0;

            var pagesize = this.state.pagesize;
            var current = this.state.current;
            this.setState({
                isShowNextCurrent: !(pagesize * current >= res.Data.TotalCount)
            })

            $("#allCheck_id_Below").prop("checked", false);
            this.setState({});
        }
        else {
            messageShow(res.Message, "error")
        }
    }
   
    setBdyProductOrderBy(item) {
        //选择的排序
        let sortNav = this.state.bdySortNav;
        sortNav.forEach(x => { x.IsSelect = false });
        item.childSort = !item.childSort
        item.IsSelect = true;
        this.setState({ orderby: item.Title, sort: item.childSort ? "0" : "1" }, () => {
            this.loadList();
        });
    }
    setBdyProductFeatureId(item, op) {
        this.state.current = 1;
        op.checked = !op.checked;
        this.state.queryBdyProductDto[item.FeatureId] = item.Option.filter(x => x.checked).map(x => x.Item2).join(',');
        this.loadList();
        document.getElementById('root').click()
    }

    setBdyProductPoolId(item) {
        this.state.current = 1;
        let list = this.state.aliPoolList;
        list.forEach(x => { x.checked = false });
        if(item==null)
        {
            this.state.selectAliPoolId="";
        }else{
            this.state.selectAliPoolId=item.PoolId;
            item.checked=true;
        }
        this.loadList();
        document.getElementById('root').click()
    }
     /** 重置查询参数 */
     resetBdyParame() {
        this.state.productList = []
        this.state.selectProductNumber = 0;
        this.state.totals = 0;

        this.state.orderby = ''
        this.state.sort = ''
        this.state.fenxiaoSortNav.forEach(s => { s.IsSelect = false, s.childSort = false })
        this.state.queryBdyProductDto.Keyword = ''
        this.state.queryBdyProductDto.OrderBy = '';
        this.state.queryBdyProductDto.Sort = '';
        this.state.selectAliPoolId = '';
        this.state.aliPoolList.forEach(s => { s.checked = false });
        this.state.queryBdyProductDto.CategoryId = '';
        this.state.queryBdyProductDto.SendGoodService = '';
        this.state.queryBdyProductDto.DeliveredService = '';
        this.state.queryBdyProductDto.MaxPrice='';
        this.state.queryBdyProductDto.MinPrice='';
        this.state.bdyBybtwlybt=false;
        this.state.bdyByisJxhy=false;
        this.state.current = 1;
        this.state.bdyProductParame.features.forEach(x => { x.checked = false; x.Option.forEach(y => y.checked = false); });
        this.state.bdyProductParame.categorys.forEach(x => { x.checked = false; });
        this.state.bdyProductParame.priceChecked = false;
        this.state.searchAliPoolSelectPatform.forEach(x => { x.isActive = false; });
        this.state.selectAliPoolCategory={};
        this.state.selectAliPoolCategoryId='';
        this.loadList()
    }

    
    async loadBdyParame() {
        var res = await GetFenXiaoProductConfig();
        if (res.Success) {
            this.state.bdyProductParame.categorys = res.Data.Categorys;
        }
    }
    /**设置普通商品类目 */
    // setBdyProductCategoryId(item) {
    //     this.state.current = 1;
    //     this.setSingleFieldCheckData(
    //         this.state.bdyProductParame.categorys, item,
    //         this.state.queryBdyProductDto, 'CategoryId', item.Id, this.loadList);
    // }

    setBdyProductOfferPoolld(item) {
           //选择的排序
           let list = this.state.bdyProductParame.offerPoolldList;
           list.forEach(x => {
              if(item.Title ==x.Title)
                 x.IsSelect = true; 
               else
                 x.IsSelect = false; 
           });

           item.IsSelect = true;
           this.setState({ offerPoolldList:list}, () => {
               this.loadList();
           });
    }

    changeTagByBdy(type){
       if(type==1){
         this.setState({
            bdyBybtwlybt:!this.state.bdyBybtwlybt
         },()=>{
            this.loadList();
         })
       }else{
        this.setState({
            bdyByisJxhy:!this.state.bdyByisJxhy
         },()=>{
            this.loadList();
         })
       }
    }
  //#endregion




    //#region  加载分销货源
    async loadFenXiaoProductList() {
        if (this.state.isShowWarn) {
            Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
            return;
        }
        this.setState({ isLoading: true })
        this.state.queryFenXiaoProductDto.PageIndex = this.state.current;
        this.state.queryFenXiaoProductDto.PageSize = this.state.pagesize;

        this.state.queryFenXiaoProductDto.OrderBy = this.state.orderby;
        this.state.queryFenXiaoProductDto.Sort = this.state.sort;
        const res = await QueryFenXiaoProducts(this.state.queryFenXiaoProductDto);
        this.setState({ isLoading: false })
        if (res.Success) {
            res.Data.List.forEach(item => {
                item.ServiceList = [];
                try {
                    var serviceListJson = item.ServiceListJson;
                    if (serviceListJson != "" && serviceListJson != null && serviceListJson != undefined)
                        item.ServiceList = JSON.parse(serviceListJson);
                } catch (error) { }
            })

            this.state.productList = res.Data.List;
            this.state.totals = res.Data.TotalCount;
            this.state.selectProductNumber = 0;

            var pagesize = this.state.pagesize;
            var current = this.state.current;
            this.setState({
                isShowNextCurrent: !(pagesize * current >= res.Data.TotalCount)
            })

            $("#allCheck_id_Below").prop("checked", false);
            this.setState({});
        }
        else {
            messageShow(res.Message, "error")
        }
    }
    setSupportEncryptCreateOrderSupplier(val) {
        if (val) {
            var shopInfo = getLoginShopInfo();
            const op = {
                SiteType: 'pc',
                OperatorType: 'offerSearch_jingxuan_encryptproduct',
                Remark: '货源中心-精选货源-查询密文分销',
                PlatformType: shopInfo.loginShopPlatformType,
                ShopId: shopInfo.loginShopId,
            }
            AddSiteLogRequest(op);
        }
        this.state.isSupportEncryptCreateOrderSupplier = val;
        this.loadList();
    }
    setFenXiaoProductOrderBy(item) {
        //选择的排序
        let sortNav = this.state.fenxiaoSortNav;
        sortNav.forEach(x => { x.IsSelect = false });
        item.childSort = !item.childSort
        item.IsSelect = true;
        this.setState({ orderby: item.Title, sort: item.childSort ? "0" : "1" }, () => {
            this.loadList();
        });
    }
    setFenxiaoProductFeatureId(item, op) {
        this.state.current = 1;
        op.checked = !op.checked;
        this.state.queryFenXiaoProductDto[item.FeatureId] = item.Option.filter(x => x.checked).map(x => x.Item2).join(',');
        this.state.queryBdyProductDto[item.FeatureId] = item.Option.filter(x => x.checked).map(x => x.Item2).join(',');
        this.loadList();
        document.getElementById('root').click()
    }

    setFenxiaoProductPoolId(item, op) {
        this.state.current = 1;
        op.checked = !op.checked;
        this.state.queryFenXiaoProductDto[item.FeatureId] = item.Option.filter(x => x.checked).map(x => x.Item2).join(',');
        this.state.queryBdyProductDto[item.FeatureId] = item.Option.filter(x => x.checked).map(x => x.Item2).join(',');
        this.loadList();
        document.getElementById('root').click()
    }
   
    
    /** 重置查询参数 */
    resetFenxiaoParame() {
        this.state.productList = []
        this.state.selectProductNumber = 0;
        this.state.totals = 0;

        this.state.orderby = ''
        this.state.sort = ''
        this.state.fenxiaoSortNav.forEach(s => { s.IsSelect = false, s.childSort = false })
        this.state.queryFenXiaoProductDto.MinPrice = ''
        this.state.queryFenXiaoProductDto.MaxPrice = ''
        this.state.queryFenXiaoProductDto.Keyword = ''
        this.state.queryFenXiaoProductDto.OrderBy = '';
        this.state.queryFenXiaoProductDto.Sort = '';
        this.state.queryFenXiaoProductDto.CategoryId = '';
        this.state.queryFenXiaoProductDto.SendGoodService = '';
        this.state.queryFenXiaoProductDto.DeliveredService = '';
        this.state.current = 1;
        this.state.fenxiaoProductParame.features.forEach(x => { x.checked = false; x.Option.forEach(y => y.checked = false); });
        this.state.fenxiaoProductParame.categorys.forEach(x => { x.checked = false; });
        this.state.fenxiaoProductParame.priceChecked = false;
        this.loadList()
    }
    async loadFenxiaoParame() {
        var res = await GetFenXiaoProductConfig();
        const {jxhyParames} = this.state;
        if (res.Success) {
            this.state.fenxiaoProductParame.categorys = res.Data.Categorys;
            jxhyParames.filters = res.Data.Filters || [];
            jxhyParames.filtersRate24H = res.Data.FiltersRate24H || [];
            jxhyParames.filtersRate48H = res.Data.FiltersRate48H || [];
            jxhyParames.filtersShip = res.Data.FiltersShip || [];
            jxhyParames.filtersCiphertext = res.Data.FiltersCiphertext || [];
            
            this.setState({
                jxhyParames
            })
        }
    }
    /**设置普通商品类目 */
    setFenXiaoProductCategoryId(item) {
        this.state.current = 1;
        this.setSingleFieldCheckData(
            this.state.fenxiaoProductParame.categorys, item,
            this.state.queryFenXiaoProductDto, 'CategoryId', item.Id, this.loadList);
    }

  //#endregion

    loadJxhyDetail = async (list,selectChannels)=>{
        if(list.length == 0)
            return;
        
        const productIds = list.map(x => x.ProductId);
        const data = { productIds:productIds};
        const res = await GetAliChoicenessProductDetailRequest(data);
        if(res.Success && res.Data){
            for(const item of list){
                const product = res.Data[item.ProductId];
                item.supportEncryptChannels = []
                if(product){
                    const supportEncryptChannels = product.SupportChannel || [];
                    for(var channel of supportEncryptChannels){
                        var platormType = this.supportEncryptChannelConvertToPlatformType(channel);
                        if(platormType){
                            item.supportEncryptChannels.push(platormType)
                        }
                    }
                }
            }
        }
        if(selectChannels){
            const channels = selectChannels.split(',')
            for(const item of list){
                item.supportEncryptChannels = item.supportEncryptChannels || [];
                channels.forEach(channel =>{
                    var platormType = this.supportEncryptChannelConvertToPlatformType(channel);
                    if(item.supportEncryptChannels.includes(platormType) == false){
                        item.supportEncryptChannels.push(platormType)
                    }
                })
            }
        }
        this.setState({ })
        
    }

    supportEncryptChannelConvertToPlatformType(channel){
        if(channel == 'douyin'){
            return 'TouTiao'
        }
        if(channel == 'xiaohongshu'){
            return 'XiaoHongShu'
        }
        if(channel == 'thyny'){
            return 'Taobao'
        }
        if(channel == 'kuaishou'){
            return 'KuaiShou'
        }
        if(channel == 'pinduoduo'){
            return 'Pinduoduo'
        }
        return null;
    }

    //转成map，方便查找
    converCategroys(categorys,parent_category){
        const map = { };
        for(let cateogry of categorys){
            map[cateogry.category_id] = cateogry
            map[cateogry.category_id].cate_path = parent_category && parent_category.cate_path && [...parent_category.cate_path] || []
            map[cateogry.category_id].cate_name = parent_category && parent_category.cate_name && [...parent_category.cate_name] || []
            map[cateogry.category_id].cate_path.push(cateogry.category_id)
            map[cateogry.category_id].cate_name.push(cateogry.category_name)
            map[cateogry.category_id].children = (cateogry.children && this.converCategroys(cateogry.children,cateogry)) || []
        }
        return map;
    }
    //阿里池密文赋值
    converSearchAliPoolSelectPatform(supportEncryptChannel)
    {
        const map=[];
        for (let item of supportEncryptChannel){
            map.push({ Id: item.Id, Title: item.Title, Icon: item.Icon, isActive: false,value:item.Value})
        }
        return map;
    }

 

    render() {
        return (
            <div className='wrap'>
                <HeaderMenu />
                <main>
                    <div className='wrap-left scroll-x' >
                        <NavMenu changeNav={this.changeNav} defaultActive={"/offerSearch"} />
                    </div>
                    <div className="wrap-right">
                        {
                            <ShowWarn isShow={this.state.isShowWarn} targetUrl={this.changeNav}
                                from_action={systemConfig.zhukeAlibabaAuth === false ? 'alibaba_auth_expire' : systemConfig.zhukeTaoteAuth === false ? 'taote_auth_expire' : null}
                                alibabaNickName={getZkShopName()} taoteNickName={getTaoteShopName()} />
                        }
                        <div className='offterSearchWrap'>

                         {/*============================ 筛选条件================================= */}
                            <div className='offterSearch-navWrap' style={{ paddingBottom: 0, "backgroundColor": "#fff", "paddingTop": "24px", position: 'relative' }}>
                                { /*
                                    this.state.isSowBanner ?
                                        <div className='bannerWrap'>
                                            <span class="iconfont icon-shanchu" onClick={() => this.closeBanner()}></span>
                                            <a href='https://search.1688.com/selloffer/isv_distribution.html' target='_blank' className='imgBanner'>
                                                <img src="https://www.dgjapp.com/public/images/kaifang/banner-2023-3-31-left.png" alt="" />
                                            </a>
                                            <a href='https://search.1688.com/selloffer/isv_distribution.html' target='_blank' className='imgBanner' style={{ right: 0, left: 'unset' }}>
                                                <img src="https://www.dgjapp.com/public/images/kaifang/banner-2023-3-31-right.png" alt="" />
                                            </a>
                                        </div> : null

                                */}

                                <ul className='offterSearch-nav'>

                                    {
                                        this.state.platformNav && this.state.platformNav.map((item, index) =>
                                            <li onClick={() => this.changePlatformNav(index)} className={item.isSelect ? 'active' : ''} style={{ "display": "flex" }}>
                                                <span>{item.Title}</span>
                                                {
                                                    item.isHot ?
                                                        <svg t="1676443522951" style={{}} class="iconfont iconhot" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4000" width="24px" height="24px"><path d="M554.318 523.912c-22.604 0-40.401 8.389-53.394 25.167-12.993 16.777-19.484 38.509-19.484 65.188 0 26.333 6.349 47.859 19.05 64.577 12.697 16.723 30.117 25.079 52.256 25.079 22.603 0 40.196-8.009 52.78-24.03 12.583-16.019 18.875-37.545 18.875-64.577 0-28.193-6.117-50.479-18.353-66.849C593.816 532.1 576.572 523.912 554.318 523.912z" fill="#fa1f07" p-id="4001"></path><path d="M917.39 384.905c47.787-52.161 16.062-204.917 8.11-184.045-8 21-41 24-41 24s14-11 5-92-38-114-38-114-20 31-61 71-108 44-108 44 3-11 6-29.5-4-39.5-4-39.5-9 13-57 44c-25.084 16.2-38.421 21.474-45.442 22.819-23.303-3.732-47.202-5.68-71.558-5.68-247.976 0-449 201.024-449 449 0 247.977 201.024 449 449 449 247.977 0 449-201.023 449-449C959.5 507.053 944.405 442.632 917.39 384.905zM374.48 749.189l-57.675 0L316.805 637.512 201.46 637.512 201.46 749.19l-57.674 0L143.786 478.473l57.674 0 0 109.23 115.347 0 0-109.23 57.676 0L374.48 749.189zM648.082 714.498c-24.527 26.275-56.655 39.41-96.385 39.41-38.799 0-70.317-12.729-94.551-38.188-24.235-25.457-36.353-58.226-36.353-98.308 0-42.409 12.378-76.926 37.138-103.551 24.758-26.623 57.471-39.937 98.135-39.937 38.682 0 69.818 12.875 93.414 38.624 23.594 25.751 35.391 58.84 35.391 99.271C684.871 654 672.607 688.226 648.082 714.498zM901.934 525.66l-77.248 0 0 223.528-57.848 0L766.838 525.66l-77.073 0 0-47.188 212.169 0L901.934 525.66z" fill="#fa1f07" p-id="4002"></path></svg> :
                                                        item.isEncryptTag ?
                                                            <Tooltip className="TooltipWrap" style={{ width: "70px" }} placement='bottom' effect="dark" content={
                                                                <div style={{ width: "400px" }}>
                                                                    <p>1.当前货源下的商品铺货或者关联后，小店有订单后将进行密文下单，不消耗店铺解密额度，每日下单数量无限制</p>
                                                                    <p>2.当前货源下的商品供应商都支持打印通过店管家密文下单过去的订单</p>
                                                                </div>}>
                                                                <a class="tooltip-title" style={{ fontSize: "12px", "backgroundColor": "#10c1d3", color: "white", height: "16px" }}>密文下单<i className='puhuo-ad-back'></i></a>
                                                            </Tooltip> : null
                                                }

                                            </li>
                                        )
                                    }
                                </ul>

                              
                                {
                                    this.state.selectPlatformNav == 'tthy' ?
                                        <div>
                                            <div className='fristSearchWrap'>
                                                <div className='offterSearc-search fristSearch'>
                                                    <i className='icon-sousuo iconfont'></i>
                                                    <input
                                                        type="text"
                                                        style={{ paddingLeft: "42px" }}
                                                        onChange={(e) => { this.setFieldData(this.state.queryTaoteProductDto, 'Keyword', e.target.value) }}
                                                        onKeyDown={(e) => { if (e.key == "Enter") this.loadList() }}
                                                        placeholder="请输入搜索关键字" />
                                                    <span className="norDefBtn" onClick={() => { this.loadTaoteProductList() }}>搜索</span>
                                                </div>
                                            </div>

                                            <div className={this.state.isShowFiltbarMoreOperate ? "ph-filtbar active" : "ph-filtbar"}>
                                                <div className="ph-filtbar-up">
                                                    <span className="ph-filtbar-up-title">商品池</span>：
                                                    <ul className='ph-filtbar-up-content'>
                                                        {
                                                            this.state.taoteProductParame.pools.filter(s => s.checked).length == 0 ?
                                                                <li className='active'>全部</li> : <li onClick={() => { this.resetField(this.state.queryTaoteProductDto.Feature, 'PoolId', ...this.state.taoteProductParame.pools) }}>全部</li>
                                                        }
                                                        {
                                                            this.state.taoteProductParame.pools.map((item, index) =>
                                                                <li 
                                                                    className={item.checked ? "active" : ""}
                                                                    onClick={(e) => this.setTaoteProductPoolId(item)}  >
                                                                    {item.PoolName}
                                                                </li>
                                                            )
                                                        }
                                                    </ul>
                                                </div>
                                                <div className="ph-filtbar-up">
                                                    <span className="ph-filtbar-up-title">商品类目</span>：
                                                    <ul className='ph-filtbar-up-content'>
                                                        {
                                                            this.state.taoteProductParame.categorys.filter(s => s.checked).length == 0 ?
                                                                <li className='active'>全部</li> : <li onClick={() => { this.resetField(this.state.queryTaoteProductDto, 'CategoryId', ...this.state.taoteProductParame.categorys) }}>全部</li>
                                                        }
                                                        {
                                                            this.state.taoteProductParame.categorys.map((item, index) =>
                                                                <li
                                                                    className={item.checked ? "active" : ""}
                                                                    onClick={(e) => this.setTaoteProductCategoryId(item)}>
                                                                    {item.Name}
                                                                </li>
                                                            )
                                                        }
                                                    </ul>
                                                    <span className="moreOperate" onClick={() => this.showFiltbarMoreOperate()}>{this.state.isShowFiltbarMoreOperate ? "收起" : "更多"}<i className="iconfont icon-down"></i></span>
                                                </div>
                                                <div className="ph-filtbar-up">
                                                    <span className="ph-filtbar-up-title">筛选</span>：
                                                    <ul className='ph-filtbar-up-content' style={{ "marginLeft": "10px" }}>
                                                        <li className={this.state.taoteProductParame.priceChecked ? "active1" : ""}>
                                                            <Popover visible={this.state.taoteProductParame.priceChecked} ref={'fenxiaoProductPriceFilterPopover'} width="180" trigger="click" content={
                                                                <ul className='panel'>
                                                                    <li>
                                                                        最低价：
                                                                        <input style={{ "width": "50px" }} type="number" value={this.state.queryTaoteProductDto.MinPrice}
                                                                            onChange={(e) => { this.setFieldData(this.state.queryTaoteProductDto, 'MinPrice', e.target.value) }} />
                                                                    </li>
                                                                    <li>
                                                                        最高价：
                                                                        <input style={{ "width": "50px" }} type="number" value={this.state.queryTaoteProductDto.MaxPrice}
                                                                            onChange={(e) => { this.setFieldData(this.state.queryTaoteProductDto, 'MaxPrice', e.target.value) }} />
                                                                        <Button style={{ marginLeft: "8px" }} type='primary' size='mini' onClick={this.pricePopoverClick.bind(this, this.state.queryTaoteProductDto)}>确定</Button>
                                                                    </li>
                                                                </ul>
                                                            }>
                                                                <div className={this.state.queryTaoteProductDto.MinPrice || this.state.queryTaoteProductDto.MaxPrice ? "defColor" : ""} >
                                                                    <span>价格区间</span>
                                                                    <i className="iconfont icon-down" style={{ "fontSize": "10px", marginLeft: "4px" }}></i>
                                                                    {
                                                                        this.state.queryTaoteProductDto.MinPrice && this.state.queryTaoteProductDto.MaxPrice ?
                                                                            <span>（{this.state.queryTaoteProductDto.MinPrice}~{this.state.queryTaoteProductDto.MaxPrice}）</span> :
                                                                            this.state.queryTaoteProductDto.MinPrice ?
                                                                                <span>（{this.state.queryTaoteProductDto.MinPrice}）</span> :
                                                                                this.state.queryTaoteProductDto.MaxPrice ?
                                                                                    <span>（{this.state.queryTaoteProductDto.MaxPrice}）</span> : null
                                                                    }
                                                                </div>
                                                            </Popover>
                                                        </li>

                                                        {
                                                            this.state.taoteProductParame.features.map((item, index) =>
                                                                <li onClick={(e) => this.selectTaoteFeatureOption(item)}>
                                                                    <Popover
                                                                        visible={item.checked}
                                                                        trigger="click" content={
                                                                            <ul className=''>
                                                                                {
                                                                                    item.Option.map(s =>
                                                                                        <li onClick={() => { this.setTaoteProductFeatureId(item, s) }}>
                                                                                            {s.checked ? <input type="checkbox" checked /> : <input type="checkbox" />}
                                                                                            {s.Item1}</li>)
                                                                                }
                                                                            </ul>
                                                                        }
                                                                    >
                                                                        <div className={item.Option.filter(s => s.checked == true).length > 0 ? "defColor" : ""} >
                                                                            <span>{item.FeatureName}</span>
                                                                            <i className="iconfont icon-down" style={{ "fontSize": "10px", marginLeft: "4px" }}></i>
                                                                            {
                                                                                item.Option.filter(s => s.checked == true).length > 0 ?
                                                                                    <span>({item.Option.filter(s => s.checked == true).map(s => s.Item1).join('、')})</span> : null
                                                                            }
                                                                        </div>
                                                                    </Popover>
                                                                </li>
                                                            )
                                                        }
                                                    </ul>
                                                </div>
                                                <ul className="ph-filtbar-down">
                                                    <li className="ph-filtbar-down-leftBtns">
                                                        {
                                                            <span style={{ width: "80px" }} className={!this.state.queryTaoteProductDto.OrderBy ? "active" : ""}
                                                                onClick={(e) => this.setTaoteDefaultOrderBy()}>综合</span>
                                                        }
                                                        {
                                                            this.state.taoteProductParame.orderBys.map((item, index) =>
                                                                <span className={item.checked ? "active" : ""} style={{ width: "80px" }} onClick={(e) => this.setTaoteProductOrderBy(item)}>{item.FieldName}
                                                                    {
                                                                        <span className={item.childSort ? 'ph-filtbar-down-leftBtns-icons active' : 'ph-filtbar-down-leftBtns-icons'}><i className='icon-down-fill iconfont'></i><i className='icon-down-fill iconfont'></i></span>
                                                                    }
                                                                </span>
                                                            )
                                                        }

                                                    </li>
                                                    <li style={{ "cursor": "pointer" }} onClick={() => { this.resetTaoteParame() }}>重置所有筛选</li>
                                                </ul>
                                            </div>
                                        </div>
                                        : null
                                }
                                {
                                    this.state.selectPlatformNav == 'jxhy' ?
                                        <div>
                                            <div className='fristSearchWrap'>
                                                <div className='offterSearc-search fristSearch'>
                                                    <i className='icon-sousuo iconfont'></i>
                                                    <input type="text" id="productTitleId" placeholder="请输入搜索关键字" onKeyDown={(e) => { if (e.key == "Enter") this.loadList() }} />
                                                    <span className="norDefBtn" onClick={this.searchProduct}>搜索</span>
                                                </div>
                                            </div>

                                            <div className={this.state.isShowFiltbarMoreOperate ? "ph-filtbar active" : "ph-filtbar"}>
                                                <div className="ph-filtbar-up" style={{ position:"relative" }}>
                                                    <span className="ph-filtbar-up-title">类目</span>：
                                                    {/* <ShowModal showModal={true} titleName={"选择类目"} cancelDailog={() => this.cancelModul("showSelectCategoryModule")} hideBtn={true} showLeftTopBtn={true}>
                                                        <SelectCategoryModule
                                                            showSelectCategoryModule={this.state.showSelectCategoryModule}
                                                            targetPlatformType={this.state.selectCategoryByPlatform}
                                                            targetShopId={this.state.selectCategoryByShopId}
                                                            selectCategory={this.selectCategory}
                                                        />
                                                    </ShowModal> */}
                                                    
                                                    <div className="ph-filtbar-up-content-category-warp" style={{display: this.state.isCategoryShow ? 'none' : 'none'}} 
                                                        onMouseEnter={()=>{this.showCategory(this.state.isCategory,this)}}
                                                    >
                                                        {/* {this.state.isCategory.category_name} */}
                                                        <div>
                                                            {
                                                                this.state.isCategory.children && this.state.isCategory.children.map((item, index) =>
                                                                    <div className="ph-filtbar-up-content-category-box flex">
                                                                        <div className="ph-filtbar-up-content-category-l" 
                                                                            onClick={(e) => this.categorySelect(e, item.category_id, item.checked,item)}>
                                                                            {item.category_name}<i className="iconfont icon-down"></i>
                                                                        </div>
                                                                        
                                                                        <ul className='ph-filtbar-up-content-category-r'>
                                                                            {
                                                                                item.children && Object.values(item.children).length && Object.values(item.children).map((item1, index1) =>
                                                                                    <li onClick={(e) => this.categorySelect(e, item1.category_id, item.checked,this.state.categoryMap[item1.category_id])}>{item1.category_name}</li>
                                                                                )
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                    
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                    <ul className='ph-filtbar-up-content ph-filtbar-up-content-category'>
                                                        {
                                                            this.state.categoryList.map((item, index) =>
                                                                <li className={item.Id == this.state.selectCategory.category_id ? "ph-filtbar-up-content-category-li active" : "ph-filtbar-up-content-category-li"} 
                                                                >
                                                                    {/* mouseenter */}
                                                                    <span 
                                                                        id={'category_'+item.Id}
                                                                        // onClick={(e) => this.state.categoryMap && this.categoryChange(e, item.Id, item.checked,this.state.categoryMap[item.Id])}
                                                                        onClick={()=>this.state.categoryMap && this.showCategory(this.state.categoryMap[item.Id],'category_'+item.Id)}
                                                                        // onFocus={()=>{ this.showCategory(this.state.categoryMap[item.Id])}}
                                                                        // onMouseEnter={()=>this.state.categoryMap && this.showCategory(this.state.categoryMap[item.Id],'category_'+item.Id)}
                                                                        // onMouseLeave={()=>this.hideCategory()}
                                                                    >{item.Name}</span>
                                                                     
                                                                    {/* {
                                                                        this.state.categoryMap && this.state.categoryMap[item.Id] ?
                                                                        <div className='ph-filtbar-up-content-category-warp' style={{display:'flex'}}>{this.categoryRender(this.state.categoryMap[item.Id].children,this.state.categoryMap[item.Id])}</div>:null
                                                                        
                                                                    } */}
                                                                </li>
                                                            )
                                                        }
                                                    </ul>
                                                    <span className="moreOperate" onClick={() => this.showFiltbarMoreOperate()}>{this.state.isShowFiltbarMoreOperate ? "收起" : "更多"}<i className="iconfont icon-down"></i></span>
                                                </div>

                                                <div className="ph-filtbar-up">
                                                    <span className="ph-filtbar-up-title">榜单</span>：
                                                    <ul className='ph-filtbar-up-content'>
                                                    {
                                                        this.state.tagList.map((item, index) =>
                                                            <li>
                                                                <label>
                                                                    <input onChange={(e) => this.changeTag(e, item.RuleId, item.checked)} checked={item.checked} type="checkbox" name="tagInputName" />
                                                                    <span> {item.RuleName}</span>
                                                                </label>
                                                            </li>
                                                        )
                                                    }
                                                    </ul>
                                                </div>

                                                <div className="ph-filtbar-up">
                                                    <span className="ph-filtbar-up-title">筛选</span>：
                                                    <ul className='ph-filtbar-up-cont' style={{display:'flex',alignItems:'center'}}>
                                                        <li>
                                                            <ul style={{display:'flex'}}>
                                                            {
                                                                this.state.jxhyParames.filters.map((item, index) =>
                                                                    <li>
                                                                        <label>
                                                                            <input onChange={(e) => this.setJxhyData(item,'checked',!item.checked)} checked={item.checked} type="checkbox"  />
                                                                            <span>{item.text}</span>
                                                                        </label>
                                                                    </li>
                                                                )
                                                            }
                                                            </ul>
                                                        </li>
                                                            
                                                        {
                                                            this.state.jxhyParames.filtersShip.length > 0 ?
                                                            <li className='popover'>
                                                                <MyPopover 
                                                                    trigger="click"
                                                                    content={
                                                                        <div className='myPopover-contetnt'>
                                                                        {
                                                                                this.state.jxhyParames.filtersShip.map((item, index) =>
                                                                                <div className='myPopover-contetnt-item'>
                                                                                    <input onChange={(e) => this.setJxhyData(item,'checked',!item.checked,this.state.jxhyParames.filtersShip)} checked={item.checked} type="checkbox"  />
                                                                                    {item.text}
                                                                                </div>
                                                                            )
                                                                        }
                                                                    </div>
                                                                    }
                                                                >
                                                                    {
                                                                        this.state.jxhyParames.filtersShip.filter(s => s.checked == true).length > 0 ? 
                                                                        <div className='defColor flex active'>
                                                                            <span>{this.state.jxhyParames.filtersShip.filter(s => s.checked == true).map(s => s.text).join('、')}</span>
                                                                            <span className='iconfont icon-shanchu hover' style={{fontSize:'12px'}} onClick={()=>{ this.resetJxhyFilterData('checked',this.state.jxhyParames.filtersShip)}}></span>
                                                                        </div>:
                                                                        <div>
                                                                            <span>发货时效</span>
                                                                            <i className="iconfont icon-down" style={{ "fontSize": "10px", marginLeft: "4px" }}></i>
                                                                        </div>
                                                                    }
                                                                </MyPopover>
                                                            </li>:null
                                                        }
                                                        
                                                        {
                                                            this.state.jxhyParames.filtersRate24H.length > 0 ?
                                                            <li className='popover'>
                                                                <MyPopover
                                                                trigger="click" content={
                                                                    <div className='myPopover-contetnt'>
                                                                        {
                                                                                this.state.jxhyParames.filtersRate24H.map((item, index) =>
                                                                                <div className='myPopover-contetnt-item'>
                                                                                    <input onChange={(e) => this.setJxhyData(item,'checked',!item.checked,this.state.jxhyParames.filtersRate24H)} checked={item.checked} type="checkbox"  />
                                                                                    {item.text}
                                                                                </div>
                                                                            )
                                                                        }
                                                                    </div>
                                                                }
                                                                >
                                                                    {
                                                                        this.state.jxhyParames.filtersRate24H.filter(s => s.checked == true).length > 0 ? 
                                                                        <div className='defColor flex active'>
                                                                            <span>24小时揽收率</span>
                                                                            <span>:{this.state.jxhyParames.filtersRate24H.filter(s => s.checked == true).map(s => s.text).join('、')}</span>
                                                                            <span className='iconfont icon-shanchu hover' style={{fontSize:'12px'}} onClick={()=>{ this.resetJxhyFilterData('checked',this.state.jxhyParames.filtersRate24H)}}></span>
                                                                        </div>:
                                                                        <div>
                                                                            <span>24小时揽收率</span>
                                                                            <i className="iconfont icon-down" style={{ "fontSize": "10px", marginLeft: "4px" }}></i>
                                                                        </div>
                                                                    }
                                                                </MyPopover>
                                                            </li>:null
                                                        }
                                                        {/* {
                                                            this.state.jxhyParames.filtersRate24H.length > 0 ?
                                                            <li>
                                                                <span>24小时揽收率</span>
                                                                <ul>
                                                                    {
                                                                        this.state.jxhyParames.filtersRate24H.map((item, index) =>
                                                                        <li>
                                                                            <label>
                                                                                <input onChange={(e) => this.setJxhyData(item,'checked',!item.checked)} checked={item.checked} type="checkbox"  />
                                                                                <span>{item.text}</span>
                                                                            </label>
                                                                        </li>
                                                                    )
                                                                    }
                                                                </ul>
                                                            </li>:null
                                                        } */}
                                                        {
                                                            this.state.jxhyParames.filtersRate48H.length > 0 ?
                                                            <li className='popover'>
                                                                <MyPopover
                                                                trigger="click" content={
                                                                    <div className='myPopover-contetnt'>
                                                                        {
                                                                            this.state.jxhyParames.filtersRate48H.map((item, index) =>
                                                                            <div className='myPopover-contetnt-item'>
                                                                                <input onChange={(e) => this.setJxhyData(item,'checked',!item.checked,this.state.jxhyParames.filtersRate48H)} checked={item.checked} type="checkbox"  />
                                                                                {item.text}
                                                                            </div>
                                                                            )
                                                                        }
                                                                    </div>
                                                                }
                                                                >
                                                                {
                                                                    this.state.jxhyParames.filtersRate48H.filter(s => s.checked == true).length > 0 ? 
                                                                    <div className='defColor flex active'ph-filtbar-up-cont>
                                                                        <span>48小时揽收率</span>
                                                                        <span>:{this.state.jxhyParames.filtersRate48H.filter(s => s.checked == true).map(s => s.text).join('、')}</span>
                                                                        <span className='iconfont icon-shanchu hover' style={{fontSize:'12px'}} onClick={()=>{ this.resetJxhyFilterData('checked',this.state.jxhyParames.filtersRate48H)}}></span>
                                                                    </div>:
                                                                    <div>
                                                                        <span>48小时揽收率</span>
                                                                        <i className="iconfont icon-down" style={{ "fontSize": "10px", marginLeft: "4px" }}></i>
                                                                    </div>
                                                                }
                                                                </MyPopover>
                                                            </li>:null
                                                        }
                                                        {/* {
                                                            this.state.jxhyParames.filtersRate48H.length > 0 ?
                                                            <li>
                                                                <span>48小时揽收率</span>
                                                                <ul>
                                                                    {
                                                                        this.state.jxhyParames.filtersRate48H.map((item, index) =>
                                                                        <li>
                                                                            <label>
                                                                                <input onChange={(e) => this.setJxhyData(item,'checked',!item.checked)} checked={item.checked} type="checkbox"  />
                                                                                <span>{item.text}</span>
                                                                            </label>
                                                                        </li>
                                                                    )
                                                                    }
                                                                </ul>
                                                            </li>:null
                                                        } */}
                                                        {
                                                            systemConfig.isTouTiao() || systemConfig.isKuaiShou()?
                                                            <li>
                                                                <div class="my-select-02">
                                                                    <div class={this.state.isShowMySelect ? "my-select-02-inputWrap active" : "my-select-02-inputWrap"}    >
                                                                        <div class="my-select-02-inputWrap-main" onClick={(e) => this.showMySelect(e)}>
                                                                            <div className='newIcon' style={{top:'-9px',right:'-31px'}}>new</div>
                                                                            <div class="my-select-02-inputWrap-title" id="inputWrap_default" data-id="3672">
                                                                                <div className='my-select-02-inputWrap-title-left popoverCommon'>
                                                                                    <span>密文下单</span>
                                                                                    <i>？</i>
                                                                                    <div className='popoverCommon-warn' style={{width:'560px',bottom:'31px',lineHeight:'25px',color:'#333'}}>
                                                                                        <div>1.带有密文标签的商品，表示该供应商支持打印使用密文下单过去的订单，可以不消耗店铺解密额度</div>
                                                                                        <div>2.铺货或关联了密文标签商品，系统会自动对供应商进行标记使用密文下单</div>
                                                                                        <div>3.系统自动检测供应商情况，对已支持密文下单的供应商进行自动标记，对不支持密文下单的供应商进行自动取消标记</div>
                                                                                        <div>4.系统自动识别供应商是否支持密文下单，自动标记或取消</div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className='my-select-02-inputWrap-title-right'>
                                                                                    {
                                                                                        this.state.searchSelectPatform.map((item, index) =>
                                                                                            item.isActive ?
                                                                                                <label>
                                                                                                    <PlatformName platformType={item.Icon} iconSize={"tinyIcon"} isHidePatformName={true} />
                                                                                                    <span class="my-select-03-expressTemplateWrap-title">{item.Title}</span>
                                                                                                </label> : null
                                                                                        )
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            <i class="iconfont icon-down"></i>
                                                                        </div>
                                                                        <div class="my-select-02-inputWrap-content">
                                                                            <ul class="my-select-02-expressTemplateWrap  myscroll-x" id="my_select_expressTemplateWrap">
                                                                                {
                                                                                    this.state.searchSelectPatform.map((item, index) =>
                                                                                        <li onClick={() => this.chooseSearchtPatform(item.Id)} class={item.isActive ? "my-select-02-expressTemplateWrap-item active" : "my-select-02-expressTemplateWrap-item"} data-id={item.Id}>
                                                                                            <label>
                                                                                                <PlatformName platformType={item.Icon} iconSize={"tinyIcon"} isHidePatformName={true} />
                                                                                                <span class="my-select-02-expressTemplateWrap-title">{item.Title}</span>
                                                                                                <i class="iconfont icon-dagou"></i>
                                                                                            </label>
                                                                                        </li>
                                                                                    )
                                                                                }
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </li>:null
                                                        }
                                                    </ul>
                                                </div>

                                                <ul className="ph-filtbar-down">
                                                    <li className="ph-filtbar-down-leftBtns">
                                                        {/* <span onClick={(e) => this.orderbyChange(e, "")}>综合</span>
                                                        <span onClick={(e) => this.orderbyChange(e, "salesCnt")}>销量<i className='icon-paixu2 iconfont'></i></span>
                                                        <span onClick={(e) => this.orderbyChange(e, "minPrice")}>价格<i className='icon-paixu2 iconfont'></i></span> */}
                                                        {/* {
                                                            this.state.sortNav.map((item, index) =>
                                                                <span className={item.IsSelect ? "active" : ""} onClick={(e) => this.orderbyChange(e, `${item.Title}`)}>{item.Name}
                                                                    {
                                                                        item.isIcon ? <span className={item.childSort ? 'ph-filtbar-down-leftBtns-icons active' : 'ph-filtbar-down-leftBtns-icons'}><i className='icon-down-fill iconfont'></i><i className='icon-down-fill iconfont'></i></span> : ""
                                                                    }
                                                                </span>
                                                            )
                                                        } */}
                                                    </li>
                                                    {/* {
                                                        systemConfig.isTouTiao() || systemConfig.isKuaiShou()?
                                                        <li>
                                                            <div class="my-select-02">
                                                                <div class={this.state.isShowMySelect ? "my-select-02-inputWrap active" : "my-select-02-inputWrap"}    >
                                                                    <div class="my-select-02-inputWrap-main" onClick={(e) => this.showMySelect(e)}>
                                                                        <div className='newIcon' style={{top:'-9px',right:'-31px'}}>new</div>
                                                                        <div class="my-select-02-inputWrap-title" id="inputWrap_default" data-id="3672">
                                                                            <div className='my-select-02-inputWrap-title-left popoverCommon'>
                                                                                <span>密文下单</span>
                                                                                <i>？</i>
                                                                                <div className='popoverCommon-warn' style={{width:'560px',bottom:'31px',lineHeight:'25px',color:'#333'}}>
                                                                                    <div>1.带有密文标签的商品，表示该供应商支持打印使用密文下单过去的订单，可以不消耗店铺解密额度</div>
                                                                                    <div>2.铺货或关联了密文标签商品，系统会自动对供应商进行标记使用密文下单</div>
                                                                                    <div>3.系统自动检测供应商情况，对已支持密文下单的供应商进行自动标记，对不支持密文下单的供应商进行自动取消标记</div>
                                                                                    <div>4.系统自动识别供应商是否支持密文下单，自动标记或取消</div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='my-select-02-inputWrap-title-right'>
                                                                                {
                                                                                    this.state.searchSelectPatform.map((item, index) =>
                                                                                        item.isActive ?
                                                                                            <label>
                                                                                                <PlatformName platformType={item.Icon} iconSize={"tinyIcon"} isHidePatformName={true} />
                                                                                                <span class="my-select-02-expressTemplateWrap-title">{item.Title}</span>
                                                                                            </label> : null
                                                                                    )
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <i class="iconfont icon-down"></i>
                                                                    </div>
                                                                    <div class="my-select-02-inputWrap-content">
                                                                        <ul class="my-select-02-expressTemplateWrap  myscroll-x" id="my_select_expressTemplateWrap">
                                                                            {
                                                                                this.state.searchSelectPatform.map((item, index) =>
                                                                                    <li onClick={() => this.chooseSearchtPatform(item.Id)} class={item.isActive ? "my-select-02-expressTemplateWrap-item active" : "my-select-02-expressTemplateWrap-item"} data-id={item.Id}>
                                                                                        <label>
                                                                                            <PlatformName platformType={item.Icon} iconSize={"tinyIcon"} isHidePatformName={true} />
                                                                                            <span class="my-select-02-expressTemplateWrap-title">{item.Title}</span>
                                                                                            <i class="iconfont icon-dagou"></i>
                                                                                        </label>
                                                                                    </li>
                                                                                )
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </li>:null
                                                    } */}

                                                    {
                                                        // <li>
                                                        //     {
                                                        //         systemConfig.isTouTiao() ?
                                                        //             <label>
                                                        //                 <input type="checkbox" name="tagInputName" onChange={(e) => { this.setSupportEncryptCreateOrderSupplier(e.target.checked) }} />

                                                        //                 <Tooltip placement="top" width="200" trigger="hover" content={
                                                        //                     <div>
                                                        //                         <p>1.铺货或者关联密文分销商品后，小店有订单后将进行密文下单，不消耗店铺解密额度，每日下单数量无限制</p>
                                                        //                         <p>2.当前货源下的商品供应商都支持打印通过店管家密文下单过去的订单</p>
                                                        //                     </div>
                                                        //                 }>
                                                        //                     <span>
                                                        //                         <span>密文分销商品</span>
                                                        //                         <svg t="1676443522951" class="iconfont iconhot" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4000" width="16px" height="16px"><path d="M554.318 523.912c-22.604 0-40.401 8.389-53.394 25.167-12.993 16.777-19.484 38.509-19.484 65.188 0 26.333 6.349 47.859 19.05 64.577 12.697 16.723 30.117 25.079 52.256 25.079 22.603 0 40.196-8.009 52.78-24.03 12.583-16.019 18.875-37.545 18.875-64.577 0-28.193-6.117-50.479-18.353-66.849C593.816 532.1 576.572 523.912 554.318 523.912z" fill="#fa1f07" p-id="4001"></path><path d="M917.39 384.905c47.787-52.161 16.062-204.917 8.11-184.045-8 21-41 24-41 24s14-11 5-92-38-114-38-114-20 31-61 71-108 44-108 44 3-11 6-29.5-4-39.5-4-39.5-9 13-57 44c-25.084 16.2-38.421 21.474-45.442 22.819-23.303-3.732-47.202-5.68-71.558-5.68-247.976 0-449 201.024-449 449 0 247.977 201.024 449 449 449 247.977 0 449-201.023 449-449C959.5 507.053 944.405 442.632 917.39 384.905zM374.48 749.189l-57.675 0L316.805 637.512 201.46 637.512 201.46 749.19l-57.674 0L143.786 478.473l57.674 0 0 109.23 115.347 0 0-109.23 57.676 0L374.48 749.189zM648.082 714.498c-24.527 26.275-56.655 39.41-96.385 39.41-38.799 0-70.317-12.729-94.551-38.188-24.235-25.457-36.353-58.226-36.353-98.308 0-42.409 12.378-76.926 37.138-103.551 24.758-26.623 57.471-39.937 98.135-39.937 38.682 0 69.818 12.875 93.414 38.624 23.594 25.751 35.391 58.84 35.391 99.271C684.871 654 672.607 688.226 648.082 714.498zM901.934 525.66l-77.248 0 0 223.528-57.848 0L766.838 525.66l-77.073 0 0-47.188 212.169 0L901.934 525.66z" fill="#fa1f07" p-id="4002"></path></svg>
                                                        //                     </span>
                                                        //                 </Tooltip>
                                                        //                 {/* <svg t="1676443522951" style={{}} class="iconfont iconhot" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4000" width="16px" height="16px"><path d="M554.318 523.912c-22.604 0-40.401 8.389-53.394 25.167-12.993 16.777-19.484 38.509-19.484 65.188 0 26.333 6.349 47.859 19.05 64.577 12.697 16.723 30.117 25.079 52.256 25.079 22.603 0 40.196-8.009 52.78-24.03 12.583-16.019 18.875-37.545 18.875-64.577 0-28.193-6.117-50.479-18.353-66.849C593.816 532.1 576.572 523.912 554.318 523.912z" fill="#fa1f07" p-id="4001"></path><path d="M917.39 384.905c47.787-52.161 16.062-204.917 8.11-184.045-8 21-41 24-41 24s14-11 5-92-38-114-38-114-20 31-61 71-108 44-108 44 3-11 6-29.5-4-39.5-4-39.5-9 13-57 44c-25.084 16.2-38.421 21.474-45.442 22.819-23.303-3.732-47.202-5.68-71.558-5.68-247.976 0-449 201.024-449 449 0 247.977 201.024 449 449 449 247.977 0 449-201.023 449-449C959.5 507.053 944.405 442.632 917.39 384.905zM374.48 749.189l-57.675 0L316.805 637.512 201.46 637.512 201.46 749.19l-57.674 0L143.786 478.473l57.674 0 0 109.23 115.347 0 0-109.23 57.676 0L374.48 749.189zM648.082 714.498c-24.527 26.275-56.655 39.41-96.385 39.41-38.799 0-70.317-12.729-94.551-38.188-24.235-25.457-36.353-58.226-36.353-98.308 0-42.409 12.378-76.926 37.138-103.551 24.758-26.623 57.471-39.937 98.135-39.937 38.682 0 69.818 12.875 93.414 38.624 23.594 25.751 35.391 58.84 35.391 99.271C684.871 654 672.607 688.226 648.082 714.498zM901.934 525.66l-77.248 0 0 223.528-57.848 0L766.838 525.66l-77.073 0 0-47.188 212.169 0L901.934 525.66z" fill="#fa1f07" p-id="4002"></path></svg> */}
                                                        //             </label> : null
                                                        //     }
                                                        // </li>
                                                    }
                                                    
                                                    {/* {
                                                        this.state.tagList.map((item, index) =>
                                                            <li>
                                                                <label>
                                                                    <input onChange={(e) => this.changeTag(e, item.RuleId, item.checked)} checked={item.checked} type="checkbox" name="tagInputName" />
                                                                    <span> {item.RuleName}</span>
                                                                </label>
                                                            </li>
                                                        )
                                                    } */}
                                                </ul>
                                            </div>
                                        </div>
                                        : null
                                }
                                {/* {
                                    this.state.selectPlatformNav == 'hyzx' ?
                                        <div className='offterSearc-search' style={{ paddingBottom: "15px", "display": "flex", "justifyContent": "center" }}>
                                            <div className="offterSearch-btns" style={{ "marginLeft": "-550px" }}>
                                                <div className="offterSearch-btns-title">{this.state.changeSearchNav}<i className='iconfont icon-down'></i></div>
                                                <div className='offterSearch-btns-content'>
                                                    <span className={this.state.findValue == "goods" ? "buttonByA" : "buttonByB"} onClick={() => this.findButton("goods")}>找货源</span>
                                                    <span className={this.state.findValue == "factory" ? "buttonByA" : "buttonByB"} onClick={() => this.findButton("factory")}>找工厂</span>
                                                </div>
                                            </div>
                                            <input id="zhukeOfferSearchInputId" />
                                            <span className="norDefBtn" onClick={() => this.queryButton()}>搜索</span>
                                        </div> : null
                                } */}

                              {
                                    this.state.selectPlatformNav == 'bdyhy' ?
                                        <div>
                                            <div className='fristSearchWrap'>
                                                <div className='offterSearc-search fristSearch'>
                                                    <i className='icon-sousuo iconfont'></i>
                                                    <input
                                                        type="text"
                                                        style={{ paddingLeft: "42px" }}
                                                        onChange={(e) => { this.setFieldData(this.state.queryBdyProductDto, 'Keyword', e.target.value) }}
                                                        value={this.state.queryBdyProductDto.Keyword}
                                                        onKeyDown={(e) => { if (e.key == "Enter") this.loadList() }}
                                                        placeholder="请输入搜索关键字" />
                                                    <span className="norDefBtn" onClick={() => { this.loadList() }}>搜索</span>
                                                </div>
                                            </div>
                                            {/*货盘池 */}
                                            <div className={this.state.isShowFiltbarMoreOperate ? "ph-filtbar active" : "ph-filtbar"}>
                                                <div className="ph-filtbar-up">
                                                    <span className="ph-filtbar-up-title">货盘</span>：
                                                    <ul className='ph-filtbar-up-content'>
                                                       <li className={this.state.selectAliPoolId=="" ? "active" : ""}   onClick={(e) => this.setBdyProductPoolId(null)}>全部</li> 
                                                        {
                                                            this.state.aliPoolList.map((item, index) =>
                                                                <li title={item.Desc}
                                                                    className={item.checked ? "active" : ""}
                                                                    onClick={(e) => this.setBdyProductPoolId(item)}>                                                                    
                                                                    {item.PoolName}
                                                                    
                                                                </li>
                                                            )
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className={this.state.isShowFiltbarMoreOperate ? "ph-filtbar active" : "ph-filtbar"}>
                                                <div className="ph-filtbar-up">
                                                    <span className="ph-filtbar-up-title">类目</span>：
                                                    <div className="ph-filtbar-up-content-category-warp" style={{display: this.state.isAliPoolCategoryShow? 'none' : 'none'}} 
                                                        onMouseEnter={()=>{this.showAliPoolCategory(this.state.isAliPoolCategory,this)}}
                                                    >                                  
                                                        <div>
                                                            {
                                                                this.state.isAliPoolCategory.children && this.state.isAliPoolCategory.children.map((item, index) =>
                                                                    <div className="ph-filtbar-up-content-category-box flex">
                                                                        <div className="ph-filtbar-up-content-category-l" 
                                                                            onClick={(e) => this.aliPoolCategorySelect(e, item.category_id, item.checked,item)}>
                                                                            {item.category_name}<i className="iconfont icon-down"></i>
                                                                        </div>
                                                                        
                                                                        <ul className='ph-filtbar-up-content-category-r'>
                                                                            {
                                                                                item.children && Object.values(item.children).length && Object.values(item.children).map((item1, index1) =>
                                                                                    <li onClick={(e) => this.aliPoolCategorySelect(e, item1.category_id, item.checked,this.state.aliPoolCategoryMap[item1.category_id])}>{item1.category_name}</li>
                                                                                )
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                    
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                    <ul className='ph-filtbar-up-content ph-filtbar-up-content-category'>
                                                        {
                                                            this.state.aliPoolCategoryList.map((item, index) =>
                                                                <li className={item.Id == this.state.selectAliPoolCategory.category_id ? "ph-filtbar-up-content-category-li active" : "ph-filtbar-up-content-category-li"} 
                                                                >
                                                                   
                                                                    <span 
                                                                        id={'category_'+item.Id}
                                                                        onClick={()=>this.state.aliPoolCategoryMap && this.showAliPoolCategory(this.state.aliPoolCategoryMap[item.Id],'category_'+item.Id)}
                                                                    >{item.Name}</span>
                                                                     
                                                                </li>
                                                            )
                                                        }
                                                    </ul>
                                                    <span className="moreOperate" onClick={() => this.showFiltbarMoreOperate()}>{this.state.isShowFiltbarMoreOperate ? "收起" : "更多"}<i className="iconfont icon-down"></i></span>
                                                  
                                                </div>

                                                

                                                <div className="ph-filtbar-up">
                                                    <span className="ph-filtbar-up-title">筛选</span>：
                                                    <ul className='ph-filtbar-up-content' style={{ "marginLeft": "10px",height: '41px',display: 'flex',alignItems:'center'}}>
                                                         <li>
                                                            <label>
                                                                <input onChange={() => this.changeTagByBdy(1)}   checked={this.state.bdyBybtwlybt}  type="checkbox" name="tagInputName" />
                                                                <span>7天无理由</span>
                                                            </label>
                                                        </li>
                                                        <li>
                                                            <label>
                                                                <input onChange={() => this.changeTagByBdy(2)} checked={this.state.bdyByisJxhy} type="checkbox" name="tagInputName" />
                                                                <span> 精选货源</span>
                                                            </label>
                                                        </li>
                                                        {
                                                            this.state.bdyProductParame.features.map((item, index) =>
                                                                <li onClick={(e) => this.selectTaoteFeatureOption(item)}>
                                                                    <Popover
                                                                        visible={item.checked}
                                                                        trigger="click" content={
                                                                            <ul className=''>
                                                                                {
                                                                                    item.Option.map(s =>
                                                                                        <li onClick={() => { this.setFenxiaoProductFeatureId(item, s) }}>
                                                                                            {s.checked ? <input type="checkbox" checked /> : <input type="checkbox" />}
                                                                                            {s.Item1}</li>)
                                                                                }
                                                                            </ul>
                                                                        }
                                                                    >
                                                                        <div className={item.Option.filter(s => s.checked == true).length > 0 ? "defColor" : ""} >
                                                                            <span>{item.FeatureName}</span>
                                                                            <i className="iconfont icon-down" style={{ "fontSize": "10px", marginLeft: "4px" }}></i>
                                                                            {
                                                                                item.Option.filter(s => s.checked == true).length > 0 ?
                                                                                    <span> （{item.Option.filter(s => s.checked == true).map(s => s.Text).join('、')}）</span> : null
                                                                            }
                                                                        </div>
                                                                    </Popover>
                                                                </li>
                                                            )
                                                        }

                                                      <li className="active1">
                                                            <Popover   width="180" trigger="click" content={
                                                                <ul className='panel'>
                                                                    <li>
                                                                        最低价：
                                                                        <input style={{ "width": "50px" }} type="number" value={this.state.queryBdyProductDto.MinPrice}
                                                                            onChange={(e) => { this.setFieldData(this.state.queryBdyProductDto, 'MinPrice', e.target.value) }} />
                                                                    </li>
                                                                    <li>
                                                                        最高价：
                                                                        <input style={{ "width": "50px" }} type="number" value={this.state.queryBdyProductDto.MaxPrice}
                                                                            onChange={(e) => { this.setFieldData(this.state.queryBdyProductDto, 'MaxPrice', e.target.value) }} />
                                                                        <Button style={{ marginLeft: "8px" }} type='primary' size='mini' onClick={this.pricePopoverClick.bind(this, this.state.queryBdyProductDto)}>确定</Button>
                                                                    </li>
                                                                </ul>
                                                            }>
                                                                <div className={this.state.queryBdyProductDto.MinPrice || this.state.queryBdyProductDto.MaxPrice ? "defColor" : ""} >
                                                                    <span>价格区间</span>
                                                                    <i className="iconfont icon-down" style={{ "fontSize": "10px", marginLeft: "4px" }}></i>
                                                                    {
                                                                        this.state.queryBdyProductDto.MinPrice && this.state.queryBdyProductDto.MaxPrice ?
                                                                            <span>（{this.state.queryBdyProductDto.MinPrice}~{this.state.queryBdyProductDto.MaxPrice}）</span> :
                                                                            this.state.queryBdyProductDto.MinPrice ?
                                                                                <span>（{this.state.queryBdyProductDto.MinPrice}）</span> :
                                                                                this.state.queryBdyProductDto.MaxPrice ?
                                                                                    <span>（{this.state.queryBdyProductDto.MaxPrice}）</span> : null
                                                                    }
                                                                </div>
                                                            </Popover>
                                                        </li>


                                                        {
                                                          systemConfig.isTouTiao() || systemConfig.isKuaiShou()?
                                                          <li>
                                                            <div class="my-select-02">
                                                                <div class={this.state.isShowMySelect ? "my-select-02-inputWrap active" : "my-select-02-inputWrap"}    >
                                                                    <div class="my-select-02-inputWrap-main" onClick={(e) => this.showMySelect(e)}>
                                                                        <div className='newIcon' style={{top:'-9px',right:'-31px'}}>new</div>
                                                                        <div class="my-select-02-inputWrap-title" id="inputWrap_default" data-id="3672">
                                                                            <div className='my-select-02-inputWrap-title-left popoverCommon'>
                                                                                <span>密文下单</span>
                                                                                <i>？</i>
                                                                                <div className='popoverCommon-warn' style={{width: '560px',bottom: '31px',lineHeight: '25px',color: 'rgb(51, 51, 51)', zIndex:' 1000000',position:' fixed',top: 'unset',bottom: 'unset',left: 'unset',marginTop: '-199px',fontSize:' 12px'}}>
                                                                                    <div>1.带有密文标签的商品，表示该供应商支持打印使用密文下单过去的订单，可以不消耗店铺解密额度</div>
                                                                                    <div>2.铺货或关联了密文标签商品，系统会自动对供应商进行标记使用密文下单</div>
                                                                                    <div>3.系统自动检测供应商情况，对已支持密文下单的供应商进行自动标记，对不支持密文下单的供应商进行自动取消标记</div>
                                                                                    <div>4.系统自动识别供应商是否支持密文下单，自动标记或取消</div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='my-select-02-inputWrap-title-right'>
                                                                                {
                                                                                    this.state.searchAliPoolSelectPatform.map((item, index) =>
                                                                                        item.isActive ?
                                                                                            <label>
                                                                                                <PlatformName platformType={item.Icon} iconSize={"tinyIcon"} isHidePatformName={true} />
                                                                                                <span class="my-select-02-expressTemplateWrap-title">{item.Title}</span>
                                                                                            </label> : null
                                                                                    )
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <i class="iconfont icon-down"></i>
                                                                    </div>
                                                                    <div class="my-select-02-inputWrap-content" style={{position: "fixed",zIndex: "1000",top: "unset",bottom: "unset",left: "unset",right: "unset",marginTop : "300px", marginLeft : "-5px"}}>
                                                                        <ul class="my-select-02-expressTemplateWrap  myscroll-x" >
                                                                            {
                                                                                this.state.searchAliPoolSelectPatform.map((item, index) =>
                                                                                    <li onClick={() => this.chooseAliPoolSearchtPatform(item.Id)} class={item.isActive ? "my-select-02-expressTemplateWrap-item active" : "my-select-02-expressTemplateWrap-item"} data-id={item.Id}>
                                                                                        <label>
                                                                                            <PlatformName platformType={item.Icon} iconSize={"tinyIcon"} isHidePatformName={true} />
                                                                                            <span class="my-select-02-expressTemplateWrap-title">{item.Title}</span>
                                                                                            <i class="iconfont icon-dagou"></i>
                                                                                        </label>
                                                                                    </li>
                                                                                )
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </li>:null
                                                      }
                                                    </ul>
                                                </div>

                                                <ul className="ph-filtbar-down">
                                                    <li className="ph-filtbar-down-leftBtns">
                                                        {
                                                            this.state.bdySortNav.map((item, index) =>
                                                                <span className={item.IsSelect ? "active" : ""}
                                                                    style={{ width: item.width ? item.width : "60px" }}
                                                                    onClick={(e) => this.setBdyProductOrderBy(item)}>
                                                                    {item.Name}
                                                                    {
                                                                        item.isIcon ? <span className={item.childSort ? 'ph-filtbar-down-leftBtns-icons active' : 'ph-filtbar-down-leftBtns-icons'}><i className='icon-down-fill iconfont'></i><i className='icon-down-fill iconfont'></i></span> : ""
                                                                    }
                                                                </span>
                                                            )
                                                        }

                                                    </li>
                                                    <li style={{ "cursor": "pointer" }} onClick={() => { this.resetBdyParame() }}>重置所有筛选</li>
                                                </ul>
                                            </div>
                                        </div> : null
                                }


                                {
                                    this.state.selectPlatformNav == 'fxhy' ?
                                        <div>
                                            <div className='fristSearchWrap'>
                                                <div className='offterSearc-search fristSearch'>
                                                    <i className='icon-sousuo iconfont'></i>
                                                    <input
                                                        type="text"
                                                        style={{ paddingLeft: "42px" }}
                                                        onChange={(e) => { this.setFieldData(this.state.queryFenXiaoProductDto, 'Keyword', e.target.value) }}
                                                        value={this.state.queryFenXiaoProductDto.Keyword}
                                                        onKeyDown={(e) => { if (e.key == "Enter") this.loadList() }}
                                                        placeholder="请输入搜索关键字" />
                                                    <span className="norDefBtn" onClick={() => { this.loadList() }}>搜索</span>
                                                </div>
                                            </div>
                                            <div className={this.state.isShowFiltbarMoreOperate ? "ph-filtbar active" : "ph-filtbar"}>
                                                <div className="ph-filtbar-up">
                                                    <span className="ph-filtbar-up-title">商品类目</span>：
                                                    <ul className='ph-filtbar-up-content'>
                                                        {
                                                            this.state.fenxiaoProductParame.categorys.map((item, index) =>
                                                                <li className={item.checked ? "active" : ""} onClick={(e) => this.setFenXiaoProductCategoryId(item)}>
                                                                    {item.Name}
                                                                </li>
                                                            )
                                                        }
                                                    </ul>
                                                    <span className="moreOperate" onClick={() => this.showFiltbarMoreOperate()}>{this.state.isShowFiltbarMoreOperate ? "收起" : "更多"}<i className="iconfont icon-down"></i></span>
                                                </div>

                                                <div className="ph-filtbar-up">
                                                    <span className="ph-filtbar-up-title">筛选</span>：
                                                    <ul className='ph-filtbar-up-content' style={{ "marginLeft": "10px" }}>
                                                        <li className={this.state.fenxiaoProductParame.priceChecked ? "active1" : ""}>
                                                            <Popover visible={this.state.fenxiaoProductParame.priceChecked} ref={'fenxiaoProductPriceFilterPopover'} width="180" trigger="click" content={
                                                                <ul className='panel'>
                                                                    <li>
                                                                        最低价：
                                                                        <input style={{ "width": "50px" }} type="number" value={this.state.queryFenXiaoProductDto.MinPrice}
                                                                            onChange={(e) => { this.setFieldData(this.state.queryFenXiaoProductDto, 'MinPrice', e.target.value) }} />
                                                                    </li>
                                                                    <li>
                                                                        最高价：
                                                                        <input style={{ "width": "50px" }} type="number" value={this.state.queryFenXiaoProductDto.MaxPrice}
                                                                            onChange={(e) => { this.setFieldData(this.state.queryFenXiaoProductDto, 'MaxPrice', e.target.value) }} />
                                                                        <Button style={{ marginLeft: "8px" }} type='primary' size='mini' onClick={this.pricePopoverClick.bind(this, this.state.queryFenXiaoProductDto)}>确定</Button>
                                                                    </li>
                                                                </ul>
                                                            }>
                                                                <div className={this.state.queryFenXiaoProductDto.MinPrice || this.state.queryFenXiaoProductDto.MaxPrice ? "defColor" : ""} >
                                                                    {/* onClick={()=>{ this.setFieldData(this.state.fenxiaoProductParame,'priceChecked',!this.state.fenxiaoProductParame.priceChecked)}} */}
                                                                    <span>价格区间</span>
                                                                    <i className="iconfont icon-down" style={{ "fontSize": "10px", marginLeft: "4px" }}></i>
                                                                    {
                                                                        this.state.queryFenXiaoProductDto.MinPrice && this.state.queryFenXiaoProductDto.MaxPrice ?
                                                                            <span>（{this.state.queryFenXiaoProductDto.MinPrice}~{this.state.queryFenXiaoProductDto.MaxPrice}）</span> :
                                                                            this.state.queryFenXiaoProductDto.MinPrice ?
                                                                                <span>（{this.state.queryFenXiaoProductDto.MinPrice}）</span> :
                                                                                this.state.queryFenXiaoProductDto.MaxPrice ?
                                                                                    <span>（{this.state.queryFenXiaoProductDto.MaxPrice}）</span> : null
                                                                    }
                                                                </div>
                                                            </Popover>
                                                        </li>
                                                        {
                                                            this.state.fenxiaoProductParame.features.map((item, index) =>
                                                                <li onClick={(e) => this.selectTaoteFeatureOption(item)}>
                                                                    <Popover
                                                                        visible={item.checked}
                                                                        trigger="click" content={
                                                                            <ul className=''>
                                                                                {
                                                                                    item.Option.map(s =>
                                                                                        <li onClick={() => { this.setFenxiaoProductFeatureId(item, s) }}>
                                                                                            {s.checked ? <input type="checkbox" checked /> : <input type="checkbox" />}
                                                                                            {s.Item1}</li>)
                                                                                }
                                                                            </ul>
                                                                        }
                                                                    >
                                                                        <div className={item.Option.filter(s => s.checked == true).length > 0 ? "defColor" : ""} >
                                                                            <span>{item.FeatureName}</span>
                                                                            <i className="iconfont icon-down" style={{ "fontSize": "10px", marginLeft: "4px" }}></i>
                                                                            {
                                                                                item.Option.filter(s => s.checked == true).length > 0 ?
                                                                                    <span> （{item.Option.filter(s => s.checked == true).map(s => s.Text).join('、')}）</span> : null
                                                                            }
                                                                        </div>
                                                                    </Popover>
                                                                </li>
                                                            )
                                                        }
                                                    </ul>
                                                </div>

                                                <ul className="ph-filtbar-down">
                                                    <li className="ph-filtbar-down-leftBtns">
                                                        {
                                                            this.state.fenxiaoSortNav.map((item, index) =>
                                                                <span className={item.IsSelect ? "active" : ""}
                                                                    style={{ width: item.width ? item.width : "60px" }}
                                                                    onClick={(e) => this.setFenXiaoProductOrderBy(item)}>
                                                                    {item.Name}
                                                                    {
                                                                        item.isIcon ? <span className={item.childSort ? 'ph-filtbar-down-leftBtns-icons active' : 'ph-filtbar-down-leftBtns-icons'}><i className='icon-down-fill iconfont'></i><i className='icon-down-fill iconfont'></i></span> : ""
                                                                    }
                                                                </span>
                                                            )
                                                        }

                                                    </li>
                                                    <li style={{ "cursor": "pointer" }} onClick={() => { this.resetFenxiaoParame() }}>重置所有筛选</li>
                                                </ul>
                                            </div>
                                        </div> : null
                                }
                            </div>
                             {/*============================ 筛选条件  end end end ================================= */}












            {/* ===============================================列表结果展示====================================================================== */}
                            {
                                this.state.selectPlatformNav == 'tthy' ?
                                    <div className='zk-maiwrap' style={{ marginBottom: "70px", marginLeft: 0, marginRight: 0 }}>
                                        <div>
                                            <ul className="ph-shopProductWrap">
                                                {
                                                    this.state.productList && this.state.productList.map((item, index) =>
                                                        <li className={item.checked ? "ph-shopProductWrap-item active" : "ph-shopProductWrap-item"}>
                                                            <span className="ph-shopProductWrap-item-dagou"><i className='iconfont icon-dagou'></i></span>
                                                            <div className="ph-shopProductWrap-item-up">
                                                                <div className="ph-shopProductWrap-item-up-img" style={{ backgroundImage: `url(${item.PicImageUrl})` }}></div>
                                                                <div className="ph-shopProductWrap-item-up-status">
                                                                    {item.PosReviewRate ? <span style={{ background: "rgba(255,137,0,0.8)" }}>好评率：{item.PosReviewRate}</span> : null}
                                                                    {item.ShipIn24 ? <span style={{ background: "rgba(255,137,0,0.8)" }}>支持24小时发货</span> : null}
                                                                    {item.CstRate ? <span style={{ background: "rgba(255,137,0,0.8)" }}>客服响应：{item.CstRate}</span> : null}
                                                                    {item.RefundRate ? <span style={{ background: "rgba(255,137,0,0.8)" }}>退货率：{item.RefundRate}</span> : null}
                                                                </div>
                                                            </div>

                                                            <div className="ph-shopProductWrap-item-mid">
                                                                <div onClick={() => huoyuanLink(item)} className="ph-shopProductWrap-item-mid-text" title={item.Title}>{item.Title}</div>
                                                                <div className="ph-shopProductWrap-item-mid-price">
                                                                    <span style={{ color: "#ff8a00" }}>¥{item.Price}</span>
                                                                    <span style={{ color: "#ff4400" }}>{item.TejiaTotalSoldQuantity}</span>
                                                                </div>
                                                            </div>
                                                            <div className="ph-shopProductWrap-item-down">
                                                                <span onClick={() => this.selectCheck(item, item.checked)}>{item.checked ? <i style={{ color: "#fea032" }}>取消选中</i> : "选中"}</span>
                                                                <span onClick={() => this.onePuHuo(item.Id, item)}>立即铺货</span>
                                                            </div>
                                                        </li>
                                                    )
                                                }
                                                {
                                                    this.state.isShowNextCurrent ?
                                                        <li className='ph-shopProductWrap-item nextProducts' onClick={() => this.changeNextPageCurrent()}>
                                                            <span className='nextProducts-title'>下一页</span>
                                                            <span className='iconfont icon-xiangxia'></span>
                                                        </li> : ''
                                                }
                                            </ul>

                                            {/* <Paginations current={this.state.current} totals={this.state.totals} pageSize={this.state.pagesize} changePageSize={(pagesize) => { this.changePageSize(pagesize) }} changePageCurrent={(current) => this.changePageCurrent(current)} /> */}
                                            <div className='paginationwrap'>
                                                <Pagination onCurrentChange={this.changePageCurrent.bind(this)} onSizeChange={this.changePageSize.bind(this)} layout="total,sizes,prev, pager, next" total={this.state.totals} pageSize={this.state.pagesize} currentPage={this.state.current} pageSizes={[10, 20, 30, 50]} />
                                            </div>
                                        </div>
                                        <div className="zk-footer" style={{ "z-index": "10" }}>
                                            <span className="zk-footer-checkWrap">
                                                <input type="checkbox" id="allCheck_id_Below" onClick={() => this.allCheckbox('below')} />
                                                <span>已选取<i style={{ fontWeight: 700, color: "#5584ff", fontSize: "14px" }}>{this.state.selectProductNumber}</i>个货品</span>
                                            </span>
                                            <span className="el-button el-button--primary" onClick={() => this.batchPuHuo()}>批量铺货</span>
                                            <span className="el-button" onClick={() => this.showPreviewDistributionList()} style={{border:"1px solid #5584ff",color:"#5584ff",backgroundColor:"#fff"}}>预览铺货</span>
                                        </div>

                                    </div> : null
                            }
                            {
                                this.state.selectPlatformNav == 'jxhy' ?
                                    <div className='zk-maiwrap' style={{ marginBottom: "70px", marginLeft: 0, marginRight: 0 }}>
                                        <div>
                                            <ul className="ph-shopProductWrap">
                                                {
                                                    this.state.productList.map((item, index) =>
                                                        <li className={item.checked ? "ph-shopProductWrap-item active" : "ph-shopProductWrap-item"}>
                                                            <span className="ph-shopProductWrap-item-dagou"><i className='iconfont icon-dagou'></i></span>
                                                            <div className="ph-shopProductWrap-item-up">
                                                                <div className="ph-shopProductWrap-item-up-img" style={{ backgroundImage: `url(${item.ProductImgUrl})` }}></div>
                                                                {/* <div className="ph-shopProductWrap-item-up-status">
                                                                    {
                                                                        item.ServiceList ?
                                                                            item.ServiceList.map((itemService, index) =>
                                                                                <span style={{ background: "rgba(255,137,0,0.8)" }}>{itemService.name}</span>
                                                                            ) : null
                                                                    }
                                                                </div> */}
                                                            </div>

                                                            <div className="ph-shopProductWrap-item-mid">
                                                                <div onClick={() => huoyuanLink(item, AddSiteLogRequest)} className="ph-shopProductWrap-item-mid-text" title={item.ProductTitle}>{item.ProductTitle}</div>
                                                                <div className="ph-shopProductWrap-item-mid-price">
                                                                    <span style={{ color: "#ff8a00" }}>¥{item.MinPrice} ~  ¥{item.MaxPrice}</span>
                                                                    <span style={{ color: "#ff4400" }}>90天销
                                                                        {
                                                                            item.SalesCnt > 10000 ? (item.SalesCnt / 10000).toFixed(2) + '万' : item.SalesCnt
                                                                        }</span>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <ul className='ph-shopProductWrap-item-ul'>
                                                                    {
                                                                        item.supportEncryptChannels && item.supportEncryptChannels.length > 0?
                                                                        <div className=''>
                                                                            <li className='ph-shopProductWrap-item-ul-li'>
                                                                                {
                                                                                    item.supportEncryptChannels.map(platformType =>
                                                                                        <PlatformName platformType={platformType} iconSize={"tinyIcon"} isHidePatformName={true} />
                                                                                    )
                                                                                }
                                                                                <span className="label">密文下单</span>
                                                                                <span className="label">包邮</span>
                                                                            </li>
                                                                            
                                                                        </div>
                                                                        :   <div className="label">包邮</div>
                                                                    }
                                                                     {

                                                                        item.ServiceList ?
                                                                            <div className="ph-shopProductWrap-item-more">
                                                                                <div className="more">...
                                                                                    <div className="more-box">
                                                                                        <ul className='more-box-ul'>
                                                                                        {
                                                                                            item.ServiceList.map((itemService, index) =>
                                                                                            <li >{itemService.name}</li>
                                                                                        )
                                                                                        }
                                                                                        </ul>
                                                                                    </div>
                                                                                </div>
                                                                               
                                                                            </div>
                                                                            
                                                                             : null
                                                                    } 
                                                                </ul>
                                                            </div>
                                                            <div className="ph-shopProductWrap-item-down">
                                                                <span onClick={() => this.selectCheck(item, item.checked)}>{item.checked ? <i style={{ color: "#fea032" }}>取消选中</i> : "选中"}</span>
                                                                <span onClick={() => this.onePuHuo(item.Id, item)}>立即铺货</span>
                                                            </div>
                                                        </li>
                                                    )
                                                }

                                                {
                                                    this.state.isShowNextCurrent ?
                                                        <li className='ph-shopProductWrap-item nextProducts' onClick={() => this.changeNextPageCurrent()}>
                                                            <span className='nextProducts-title'>下一页</span>
                                                            <span className='iconfont icon-xiangxia'></span>
                                                        </li> : ''
                                                }
                                            </ul>

                                            {/* <Paginations current={this.state.current} totals={this.state.totals} pageSize={this.state.pagesize} changePageSize={(pagesize) => { this.changePageSize(pagesize) }} changePageCurrent={(current) => this.changePageCurrent(current)} /> */}
                                            <div className='paginationwrap'>
                                                <Pagination onCurrentChange={this.changePageCurrent.bind(this)} onSizeChange={this.changePageSize.bind(this)} layout="total,sizes,prev, pager, next" total={this.state.totals} pageSize={this.state.pagesize} currentPage={this.state.current} pageSizes={[10, 20, 30, 50]} />
                                            </div>
                                        </div>
                                        <div className="zk-footer" style={{ "z-index": "10" }}>
                                            <span className="zk-footer-checkWrap">
                                                <input type="checkbox" id="allCheck_id_Below" onClick={() => this.allCheckbox('below')} />
                                                <span>已选取<i style={{ fontWeight: 700, color: "#5584ff", fontSize: "14px" }}>{this.state.selectProductNumber}</i>个货品</span>
                                            </span>
                                            <span className="el-button el-button--primary" onClick={() => this.batchPuHuo()}>批量铺货</span>
                                            <span className="el-button" onClick={() => this.showPreviewDistributionList()} style={{border:"1px solid #5584ff",color:"#5584ff",backgroundColor:"#fff"}}>预览铺货</span>
                                        </div>

                                    </div> : null
                            }
                            {/* {
                                this.state.selectPlatformNav == 'hyzx' ?
                                    <div className='zk-maiwrap' style={{ marginLeft: 0, marginRight: 0 }}>
                                        <div className="zk-maiwrap" style={{ justifyContent: "center", width: "100%" }}>
                                            <iframe className='zk-maiwrap-iframe' src='https://search.1688.com/selloffer/isv_distribution.html'></iframe>
                                        </div>
                                    </div> : null
                            } */}
                          
                            {
                                this.state.selectPlatformNav == 'bdyhy' ?
                                    <div className='zk-maiwrap' style={{ marginBottom: "70px", marginLeft: 0, marginRight: 0 }}>
                                        <div>
                                            <ul className="ph-shopProductWrap">
                                                {
                                                    this.state.productList.map((item, index) =>
                                                        <li className={item.checked ? "ph-shopProductWrap-item active" : "ph-shopProductWrap-item"}>
                                                            <span className="ph-shopProductWrap-item-dagou"><i className='iconfont icon-dagou'></i></span>
                                                            <div className="ph-shopProductWrap-item-up">
                                                                <div className="ph-shopProductWrap-item-up-img" style={{ backgroundImage: `url(${item.ProductImgUrl})` }}></div>
                                                                <div className="ph-shopProductWrap-item-up-status">
                                                                    {
                                                                        item.ServiceList ?
                                                                            item.ServiceList.map((itemService, index) =>
                                                                                <span style={{ background: "rgba(255,137,0,0.8)" }}>{itemService.name}</span>
                                                                            ) : null
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div className="ph-shopProductWrap-item-mid">
                                                                <div onClick={() => huoyuanLink(item)} className="ph-shopProductWrap-item-mid-text" title={item.ProductTitle}>{item.ProductTitle}</div>
                                                                <div className="ph-shopProductWrap-item-mid-price">
                                                                    <span style={{ color: "#ff8a00" }}>¥{item.MinPrice} ~  ¥{item.MaxPrice}</span>
                                                                    {/* <span style={{ color: "#ff4400" }}>90天销{item.SalesCnt}</span> */}
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <ul className='ph-shopProductWrap-item-ul'>
                                                                    {
                                                                        item.SupportEncryptChannelList && item.SupportEncryptChannelList.length > 0?
                                                                        <div className=''>
                                                                            <li className='ph-shopProductWrap-item-ul-li'>
                                                                                {
                                                                                    item.SupportEncryptChannelList.map(platformType =>
                                                                                        <PlatformName platformType={platformType} iconSize={"tinyIcon"} isHidePatformName={true} />
                                                                                    )
                                                                                }
                                                                                <span className="label">密文下单</span>
                                                                                <span className="label">包邮</span>
                                                                            </li>
                                                                            
                                                                        </div>
                                                                        :   <div className="label">包邮</div>
                                                                    }
                                                                     {

                                                                        item.ServiceList ?
                                                                            <div className="ph-shopProductWrap-item-more">
                                                                                <div className="more">...
                                                                                    <div className="more-box">
                                                                                        <ul className='more-box-ul'>
                                                                                        {
                                                                                            item.ServiceList.map((itemService, index) =>
                                                                                            <li >{itemService.name}</li>
                                                                                        )
                                                                                        }
                                                                                        </ul>
                                                                                    </div>
                                                                                </div>
                                                                               
                                                                            </div>
                                                                            
                                                                             : null
                                                                    } 
                                                                </ul>
                                                            </div>
                                                            <div className="ph-shopProductWrap-item-down">
                                                                <span onClick={() => this.selectCheck(item, item.checked)}>{item.checked ? <i style={{ color: "#fea032" }}>取消选中</i> : "选中"}</span>
                                                                <span onClick={() => this.onePuHuo(item.Id, item)}>立即铺货</span>
                                                            </div>
                                                        </li>
                                                    )
                                                }
                                                {
                                                    this.state.isShowNextCurrent ?
                                                        <li className='ph-shopProductWrap-item nextProducts' onClick={() => this.changeNextPageCurrent()}>
                                                            <span className='nextProducts-title'>下一页</span>
                                                            <span className='iconfont icon-xiangxia'></span>
                                                        </li> : ''
                                                }

                                            </ul>

                                            {/* <Paginations current={this.state.current} totals={this.state.totals} pageSize={this.state.pagesize} changePageSize={(pagesize) => { this.changePageSize(pagesize) }} changePageCurrent={(current) => this.changePageCurrent(current)} /> */}
                                            <div className='paginationwrap'>
                                                <Pagination onCurrentChange={this.changePageCurrent.bind(this)} onSizeChange={this.changePageSize.bind(this)} layout="total,sizes,prev, pager, next" total={this.state.totals} pageSize={this.state.pagesize} currentPage={this.state.current} pageSizes={[10, 20, 30, 50]} />
                                            </div>
                                        </div>
                                        <div className="zk-footer" style={{ "z-index": "10" }}>
                                            <span className="zk-footer-checkWrap">
                                                <input type="checkbox" id="allCheck_id_Below" onClick={() => this.allCheckbox('below')} />
                                                <span>已选取<i style={{ fontWeight: 700, color: "#5584ff", fontSize: "14px" }}>{this.state.selectProductNumber}</i>个货品</span>
                                            </span>
                                            <span className="el-button el-button--primary" onClick={() => this.batchPuHuo()}>批量铺货</span>
                                        </div>

                                    </div> : null
                            }
                            {
                                this.state.selectPlatformNav == 'fxhy' ?
                                    <div className='zk-maiwrap' style={{ marginBottom: "70px", marginLeft: 0, marginRight: 0 }}>
                                        <div>
                                            <ul className="ph-shopProductWrap">
                                                {
                                                    this.state.productList.map((item, index) =>
                                                        <li className={item.checked ? "ph-shopProductWrap-item active" : "ph-shopProductWrap-item"}>
                                                            <span className="ph-shopProductWrap-item-dagou"><i className='iconfont icon-dagou'></i></span>
                                                            <div className="ph-shopProductWrap-item-up">
                                                                <div className="ph-shopProductWrap-item-up-img" style={{ backgroundImage: `url(${item.ProductImgUrl})` }}></div>
                                                                <div className="ph-shopProductWrap-item-up-status">
                                                                    {
                                                                        item.ServiceList ?
                                                                            item.ServiceList.map((itemService, index) =>
                                                                                <span style={{ background: "rgba(255,137,0,0.8)" }}>{itemService.name}</span>
                                                                            ) : null
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div className="ph-shopProductWrap-item-mid">
                                                                <div onClick={() => huoyuanLink(item)} className="ph-shopProductWrap-item-mid-text" title={item.ProductTitle}>{item.ProductTitle}</div>
                                                                <div className="ph-shopProductWrap-item-mid-price">
                                                                    <span style={{ color: "#ff8a00" }}>¥{item.MinPrice} ~  ¥{item.MaxPrice}</span>
                                                                    {/* <span style={{ color: "#ff4400" }}>90天销{item.SalesCnt}</span> */}
                                                                </div>
                                                            </div>
                                                            <div className="ph-shopProductWrap-item-down">
                                                                <span onClick={() => this.selectCheck(item, item.checked)}>{item.checked ? <i style={{ color: "#fea032" }}>取消选中</i> : "选中"}</span>
                                                                <span onClick={() => this.onePuHuo(item.Id, item)}>立即铺货</span>
                                                            </div>
                                                        </li>
                                                    )
                                                }
                                                {
                                                    this.state.isShowNextCurrent ?
                                                        <li className='ph-shopProductWrap-item nextProducts' onClick={() => this.changeNextPageCurrent()}>
                                                            <span className='nextProducts-title'>下一页</span>
                                                            <span className='iconfont icon-xiangxia'></span>
                                                        </li> : ''
                                                }

                                            </ul>

                                            {/* <Paginations current={this.state.current} totals={this.state.totals} pageSize={this.state.pagesize} changePageSize={(pagesize) => { this.changePageSize(pagesize) }} changePageCurrent={(current) => this.changePageCurrent(current)} /> */}
                                            <div className='paginationwrap'>
                                                <Pagination onCurrentChange={this.changePageCurrent.bind(this)} onSizeChange={this.changePageSize.bind(this)} layout="total,sizes,prev, pager, next" total={this.state.totals} pageSize={this.state.pagesize} currentPage={this.state.current} pageSizes={[10, 20, 30, 50]} />
                                            </div>
                                        </div>
                                        <div className="zk-footer" style={{ "z-index": "10" }}>
                                            <span className="zk-footer-checkWrap">
                                                <input type="checkbox" id="allCheck_id_Below" onClick={() => this.allCheckbox('below')} />
                                                <span>已选取<i style={{ fontWeight: 700, color: "#5584ff", fontSize: "14px" }}>{this.state.selectProductNumber}</i>个货品</span>
                                            </span>
                                            <span className="el-button el-button--primary" onClick={() => this.batchPuHuo()}>批量铺货</span>
                                            <span className="el-button" onClick={() => this.showPreviewDistributionList()} style={{border:"1px solid #5584ff",color:"#5584ff",backgroundColor:"#fff"}}>预览铺货</span>
                                        </div>

                                    </div> : null
                            }


                             {/* ===============================================列表结果展示  end end end =================================== */}

                            {/* 升级版本,免费版只能铺货5次 */}
                            {
                                this.state.isShowReachListingCount ?
                                    <div className="xufeiWrap">
                                        <div className="xufeiDailog">
                                            <span className='iconfont icon-shanchu' onClick={() => this.cancelModul("isShowReachListingCount")}></span>
                                            <div className="xufeiDailog-up">
                                                <div className="xufeiDailog-up-main">
                                                    <div className="xufeiDailog-up-main-icon"></div>
                                                    <div className="xufeiDailog-up-main-content">
                                                        <span>您已成功铺货<i style={{ padding: "0 5px", fontWeight: 700, fontSize: "17px", color: "#f7941f" }}>5</i>次，达到免费版工具铺货上限，升级工具，不限铺货次数</span>
                                                        <span>已铺货成功商品订单回流采购不受影响</span>
                                                    </div>
                                                </div>
                                                <div className="xufeiDailog-up-button">
                                                    <span onClick={() => this.gotoLink(this.state.upgradeUrl)}>升级工具</span>
                                                </div>
                                            </div>
                                            <div className="xufeiDailog-main">
                                                <div className="xufeiDailog-main-left">
                                                    <div className="xufeiDailog-main-left-one">
                                                        {
                                                            this.state.versionsDistinction.map((item, index) =>
                                                                index == 0 ?
                                                                    <div className="xufeiDailog-coupon">
                                                                        <div className="xufeiDailog-coupon-title">{item.VersionName}</div>
                                                                        <div className="xufeiDailog-coupon-main">
                                                                            <span>{item.VersionText1} </span>
                                                                            <span>{item.VersionText2} </span>
                                                                        </div>
                                                                        <a className="xufeiDailog-coupon-button"> {item.VersionText3}</a>
                                                                    </div> :
                                                                    <div className="xufeiDailog-coupon active" style={{ boxShadow: "0 0 21px 0px #ffdb8d" }}>
                                                                        <div className="xufeiDailog-coupon-title"><i></i>{item.VersionName}</div>
                                                                        <div className="xufeiDailog-coupon-title02"><span>高级版特权</span></div>
                                                                        <div className="xufeiDailog-coupon-main">
                                                                            <span style={{ color: "#ff4c34", fontSize: "15px", fontWeight: "700" }}> {item.VersionText1}</span>
                                                                            <span style={{ color: "#ff4c34", fontSize: "15px", fontWeight: "700" }}>{item.VersionText2}</span>
                                                                        </div>
                                                                        <a style={{ marginTop: "10px" }} className="xufeiDailog-coupon-button"> {item.VersionText3}</a>
                                                                    </div>
                                                            )
                                                        }
                                                    </div>
                                                    <div className="xufeiDailog-main-left-two">
                                                        <div className="xufeiDailog-main-left-two-title">他们刚刚升级，一起升级无限量铺货</div>
                                                        <div className="xufeiContent" id="xufeiContent">
                                                            <ul className="xufeiItems" id="xufeiItems"></ul>
                                                        </div>
                                                    </div>
                                                    <div className="xufeiDailog-main-left-three">
                                                        {
                                                            this.state.PayInfoList.map((item, index) =>
                                                                <a className="coupon-item" onClick={() => this.gotoLink(item.URL)}>
                                                                    <div className="coupon-item-up">
                                                                        <span>{item.InfoText1}</span>
                                                                        <span>{item.InfoText2}</span>
                                                                        <i>券</i>
                                                                    </div>
                                                                    <div className="coupon-item-down">升级工具</div>
                                                                </a>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                <div className="xufeiDailog-main-right">
                                                    <div className="xufeiDailog-right-main">
                                                        <ul className="xufeiDailog-table-header">
                                                            <li style={{ width: "75px", marginLeft: 0 }}>环节</li>
                                                            <li style={{ width: "165px" }}>功能名称</li>
                                                            <li style={{ width: "120px", color: "#888" }}>免费版</li>
                                                            <li style={{ width: "132px" }}><i className="iconfontCoupon"></i>高级版</li>
                                                        </ul>
                                                        <div className="xufeiDailog-table-wrap">
                                                            <table className="xufeiDailog-table">
                                                                {
                                                                    this.state.functionDistinction.map((item, index) =>
                                                                        <tbody>
                                                                            {
                                                                                item.FunctionList.map((cItem, cIndex) =>
                                                                                    cIndex == 0 ?
                                                                                        <tr>
                                                                                            <td className="td-nth1" rowspan={item.FunctionList.length} >{item.FunctionType}</td>
                                                                                            <td className="td-nth2">{cItem.Name}</td>
                                                                                            {
                                                                                                cItem.TypeFree == "true" ?
                                                                                                    <td className="td-nth3"><i className="iconfontgou">✔</i></td> :
                                                                                                    cItem.TypeFree == "false" ?
                                                                                                        <td className="td-nth3"><i className="iconfontgou" style={{ backgroundColor: "#ff7e7e" }}>✕</i></td> :
                                                                                                        <td className="td-nth3">{cItem.TypeFree}</td>
                                                                                            }
                                                                                            {
                                                                                                cItem.TypeAdvanced == "true" ?
                                                                                                    <td className="td-nth4"><i className="iconfontgou active">✔</i></td> :
                                                                                                    cItem.TypeAdvanced == "false" ?
                                                                                                        <td className="td-nth4"><i className="iconfontgou" style={{ backgroundColor: "#ff7e7e" }}>✕</i></td> :
                                                                                                        <td className="td-nth4">{cItem.TypeAdvanced}</td>
                                                                                            }
                                                                                        </tr> :
                                                                                        <tr>
                                                                                            <td className="td-nth2">{cItem.Name}</td>
                                                                                            {
                                                                                                cItem.TypeFree == "true" ?
                                                                                                    <td className="td-nth3"><i className="iconfontgou">✔</i></td> :
                                                                                                    cItem.TypeFree == "false" ?
                                                                                                        <td className="td-nth3"><i className="iconfontgou" style={{ backgroundColor: "#ff7e7e" }}>✕</i></td> :
                                                                                                        <td className="td-nth3">{cItem.TypeFree}</td>
                                                                                            }
                                                                                            {
                                                                                                cItem.TypeAdvanced == "true" ?
                                                                                                    <td className="td-nth4"><i className="iconfontgou active">✔</i></td> :
                                                                                                    cItem.TypeAdvanced == "false" ?
                                                                                                        <td className="td-nth4"><i className="iconfontgou" style={{ backgroundColor: "#ff7e7e" }}>✕</i></td> :
                                                                                                        <td className="td-nth4">{cItem.TypeAdvanced}</td>
                                                                                            }
                                                                                        </tr>
                                                                                )
                                                                            }
                                                                        </tbody>
                                                                    )
                                                                }
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : null
                            }

                        </div>
                    </div>
                </main>


                <ShowModal width={"600px"} showModal={this.state.isShowPuHuo} hideBtn={true} titleName="选择要铺货的店铺" >
                    {/* <div className='showPuHuo-title'>
                        <span></span>
                        <span className='showPuHuo-title-right' onClick={this.addShop}><i className='iconfont icon-jia-copy1'></i>添加店铺</span>
                    </div> */}
                    <div className="offerSearch-puhuoDailog" style={{ border: "unset" }}>
                        <table className='table-style01'>
                            <tbody>
                                {
                                    this.state.shopList.length == 0 ?
                                        <tr>
                                            <td>无店铺信息，请添加店铺！</td>
                                        </tr> : null
                                }
                                {
                                    this.state.shopList.map((item, index) =>
                                        <tr>
                                            <td>
                                                <div className='shopList-item'>
                                                    {
                                                        item.IsChecked == true ? <input type="checkbox" id={"checkboxShop_" + item.Id} onClick={() => this.shopChange(item.Id)} checked={true} /> :
                                                            <input type="checkbox" id={"checkboxShop_" + item.Id} onClick={() => this.shopChange(item.Id)} />
                                                    }
                                                    <PlatformName platformType={item.PlatformType} iconSize={"smallIcon"} isHidePatformName={true} />
                                                    <span>{item.ShopName}</span>
                                                </div>
                                            </td>
                                            <td style={{ width: "250px" }}>

                                                {
                                                    this.serviceEndTimeHtml(item.ServiceEndTime, item.PayUrl, item.AuthUrl)
                                                }
                                                {/* {
                                                    item.PayUrl != "" ?
                                                        <span className="newerrorColor">店铺授权已失效，请重新授权店铺！</span>
                                                        : null
                                                }
                                                {
                                                    item.PayUrl == "" && item.AuthUrl != "" ?
                                                        <span className="newerrorColor">店铺授权已失效，请重新授权店铺！</span>
                                                        : null
                                                } */}
                                            </td>
                                            <td>
                                                {
                                                    item.PayUrl == "" && item.AuthUrl == "" ?
                                                        <span className="norSecondBtn" onClick={() => this.distributionSet(item.Id)}>铺货设置</span>
                                                        : null
                                                }

                                                {/* {
                                                    item.PayUrl != "" ?
                                                        <span className="norSecondBtn norThirthBtn" onClick={() => this.authAndPay(item.PlatformType)}>去授权</span>
                                                        : null
                                                } */}

                                                {/* 授权按钮*/}
                                                {/* {
                                                    item.PayUrl == "" && item.AuthUrl != "" ?
                                                        <span className="norSecondBtn norThirthBtn" onClick={() => this.authAndPay(item.PlatformType)}>去授权</span>
                                                        : null
                                                } */}
                                            </td>
                                        </tr>)
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        {/* {
                            this.state.offerIdList.length == 1 && this.state.selectPlatformNav != 'tthy' ?
                                <span className="showModalWrap-box-footer-btn cancleBtn" style={{ marginRight: "320px" }} onClick={() => this.relevanceShopProduct()}>关联商品</span>
                                : null
                        } */}

                        <span className="showModalWrap-box-footer-btn" onClick={() => this.distributionPreposition()}>开始铺货</span>
                        <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.cancelModul("isShowPuHuo")}>取消</span>
                    </div>
                </ShowModal>



                <ShowModal width={"680px"} showModal={this.state.isShowByDistributionSelectCategory} hideBtn={true} showLeftTopBtn={true} cancelDailog={() => this.cancelModul("isShowByDistributionSelectCategory")} titleName={"确认商品类目"}>
                    <div className="showModalWrap-box-commonContent" style={{ padding: "10px" }}>
                        <div className='categoryNameWarn'>默认智能匹配类目，智能匹配未匹配上时需手动选择商品类目</div>

                        {
                            this.state.supplierProductListByBatch.map((item, index) =>
                                <div className='supplierProductWrap' style={{ "marginTop": index > 0 ? "30px" : "0" }}>
                                    <div className='supplierProductWrap-info'>
                                        <img style={{ width: '60px', height: '60px' }} src={item.PicURI == null || item.PicURI == "" ? 'https://cbu01.alicdn.com/images/cn/market/myalibaba/newmyali/nopic.gif' : item.PicURI} alt="" />
                                        <div className='supplierProductWrap-info-left'>
                                            <span>{item.Subject}</span>
                                            <span style={{ marginTop: "5px", color: "#f7941f" }}>类目：{item.CategoryName}</span>
                                        </div>

                                    </div>
                                    <div className='supplierProductWrap-table'>
                                        {
                                            item.ShopDataList.map((shop) =>
                                                <div className='supplierProductWrap-table-tr'>
                                                    <div className='supplierProductWrap-shopName'>
                                                        <PlatformName platformType={shop.PlatformType} iconSize={"smallIcon"} isHidePatformName={true} />
                                                        <span>{shop.ShopName}</span>
                                                    </div>
                                                    {
                                                        shop.IsLoadIng ?
                                                            <div className='supplierProductWrap-operate'>
                                                                <span style={{ color: "#888" }}>加载中</span>
                                                                <img style={{ width: 25, height: 25, marginRight: "3rem" }} src="https://dgjapp.com/public/images/zhipoIcon/timg02.gif" />
                                                            </div>
                                                            : <div className='supplierProductWrap-operate' onClick={() => this.editMapping(item.ProductId, shop.ShopId, shop.PlatformType)}>
                                                                {
                                                                    shop.TargetCates.length == 0 && shop.IsButtonRed == true ?
                                                                        <div className='supplierProductWrap-choseRight' style={{ color: "#fe6f4f" }}>
                                                                            <span className='supplierProductWrap-text'>请选择类目</span>
                                                                            <span className='iconfont icon-xiangxia'></span>
                                                                        </div>
                                                                        : shop.TargetCates.length == 0 && shop.IsButtonRed == false ?
                                                                            <div className='supplierProductWrap-choseRight' >
                                                                                <span className='supplierProductWrap-text' style={{ color: "#ccc" }}>请选择类目</span>
                                                                                <span className='iconfont icon-xiangxia'></span>
                                                                            </div>
                                                                            : <div className='supplierProductWrap-choseRight'>
                                                                                <span className='supplierProductWrap-text'>{shop.CategoryNameShowText}</span>
                                                                                <span className='iconfont icon-xiangxia'></span>
                                                                            </div>
                                                                }

                                                            </div>
                                                    }


                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            )
                        }



                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span className="showModalWrap-box-footer-btn" onClick={() => this.affirmByeBatchDistribution()}>立即铺货</span>
                        <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.cancelModul("isShowByDistributionSelectCategory")}>取消</span>
                    </div>
                </ShowModal>


                <ShowModal showModal={this.state.showSelectCategoryModule} titleName={"选择类目"} cancelDailog={() => this.cancelModul("showSelectCategoryModule")} hideBtn={true} showLeftTopBtn={true}>
                    <SelectCategoryModule
                        showSelectCategoryModule={this.state.showSelectCategoryModule}
                        targetPlatformType={this.state.selectCategoryByPlatform}
                        targetShopId={this.state.selectCategoryByShopId}
                        selectCategory={this.selectCategory}
                    />
                </ShowModal>



                {/* 未设置运费模板 */}
                <ShowModal width={"500px"} showModal={this.state.isShowNotFreightTemplate} hideBtn={true} titleName="提示" >
                    <div className="showModalWrap-box-commonContent" style={{ fontSize: "16px", padding: "20px" }}>
                        <div>
                            <span>{this.state.notFreightTemplateValue}</span>
                        </div>
                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span className="showModalWrap-box-footer-btn" onClick={() => this.gotoDistributionSet()}>前往设置</span>
                        <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.cancelModul("isShowNotFreightTemplate")}>取消</span>
                    </div>
                </ShowModal>

                {/* 铺货结果 */}
                <ShowModal width={"500px"} showModal={this.state.isShowTaskCodeRes} hideBtn={true} showLeftTopBtn={true} cancelDailog={() => this.cancelModul("isShowTaskCodeRes")} >
                    <div className="showModalWrap-box-commonContent" style={{ padding: "25px" }}>
                        <div className="showModalWrap-commonContent-item" style={{ marginBottom: "25px" }}>
                            {
                                this.state.taskCodeRes.successNumber > 0 && this.state.taskCodeRes.errorNumber == 0 ?
                                    <i className="iconfont icon-dagou icofontStatus"></i> : null
                            }
                            {
                                this.state.taskCodeRes.successNumber > 0 && this.state.taskCodeRes.errorNumber > 0 ?
                                    <i className="iconfont icon-gantan icofontStatus"></i> : null
                            }
                            {
                                this.state.taskCodeRes.successNumber == 0 && this.state.taskCodeRes.errorNumber > 0 ?
                                    <i className="iconfont icon-add-fill-hover-copy icofontStatus"></i> : null
                            }

                            <span style={{ fontSize: "16px" }}>铺货任务已提交，成功：<i style={{ color: "#5584FF" }}>{this.state.taskCodeRes.successNumber}</i>，失败：<i style={{ color: "#fe6f4f" }}>{this.state.taskCodeRes.errorNumber}</i></span>
                            {
                                this.state.taskCodeRes.errorNumber != 0 ? <text>失败详情如下：</text> : null
                            }
                        </div>
                        <div style={{ padding: "20px", fontSize: "16px" }}>可在<text style={{ color: "red" }}>铺货日志</text>中查看铺货结果</div>
                        {
                            this.state.taskCodeRes.errorList.length > 0 ?
                                <div>
                                    {
                                        this.state.taskCodeRes.errorList.map((item) =>
                                            <text key={item}>{item}</text>
                                        )
                                    }
                                </div>
                                : null
                        }

                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span className="showModalWrap-box-footer-btn" onClick={() => this.props.history.push('/distributionLog')}>铺货日志</span>
                        <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.props.history.push('/')}>进入首页</span>

                    </div>
                </ShowModal>


                {/* 添加店铺步骤弹窗*/}
                {/* <ShowModal titleName={"添加" + this.state.selectPlatformName + "店铺"} width={"680px"} showModal={this.state.isShowAddShop} hideBtn={true}>
                    <div>
                        <DialogAddShopSteps sureAuthShop={this.sureAuthShop} selectPlatformName={selectPlatformName} selectPlatform={this.state.selectPlatform} showContact={this.showContact} />
                        <div className="showModalWrap-box-commonfooter">
                            <span style={{ padding: "0 30px" }} className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.closeAddShopModal()}>关闭</span>
                        </div>
                    </div>
                </ShowModal> */}
                <ShowModal width={"500px"} showModal={this.state.isShowAuthShop} sureDailog={this.successAuthShop} sureBtnName={"完成授权"} cancelDailog={() => this.cancelModul("isShowAuthShop")}>
                    <div style={{ padding: "20px", fontSize: "16px" }}>你是否已经完成授权？</div>
                </ShowModal>

                {/* 免费版，店铺超过5个，不允许点击，弹窗提示 */}
                <ShowModal hideTitle={true} width={"600px"} showModal={this.state.isShowAddShopByUpgradeApp} hideBtn={true} titleName="提示" >
                    <span className='iconfont icon-chuyidong addShopWarn-chuyi' onClick={() => this.cancelModul("isShowAddShopByUpgradeApp")}></span>
                    <div className="addShopWarn-up">
                        <i className="iconfont icon-gantan"></i>
                        <span className='addShopWarn-up-title'>免费版用户只能添加<i style={{ color: "#ffa51b", padding: "0 5px" }}>5</i>个店铺！</span>
                    </div>
                    <div className="addShopWarn-main-left-one">
                        <div className="addShopWarn-coupon">
                            <div className="addShopWarn-coupon-title">免费版</div>
                            <div className="addShopWarn-coupon-main">
                                <span>添加店铺：5个 </span>
                            </div>
                        </div>
                        <div className="addShopWarn-coupon active">
                            <div className="addShopWarn-coupon-title"><i></i>高级版</div>
                            <div className="addShopWarn-coupon-main">
                                <span style={{ color: "#ff8a00" }}> 添加店铺：50个</span>
                            </div>
                        </div>
                    </div>
                    <div className='addShopWarn-down'>
                        <span className='addShopWarn-down-span' onClick={() => this.gotoUpgradeLink()}>立即升级 添加更多店铺</span>
                    </div>
                </ShowModal>

                {/* 选择平台弹窗*/}
                {/* <ShowModal titleName={"请选择需要添加的店铺类型"} width={"660px"} showModal={this.state.isShowChoosePlatform} sureDailog={this.sureChoosePlatform} cancelDailog={() => this.cancelModul("isShowChoosePlatform")} >
                    <DialogShowPlatforms platforms={this.state.platforms} changeShops={this.changeShops} selectPlatform={this.state.selectPlatform} />
                </ShowModal> */}

                
                {/* 选择平台弹窗*/}
                <ShowModal titleName={"密文下单设置"} width={"500px"} showModal={this.state.ciphertextOrderSetDailog} sureDailog={()=>{ this.saveOrderConfig() }}  cancelDailog={() => this.cancelCiphertextOrderModul()} >
                    <div className='ciphertextOrderSet'>
                        <span>请选择密文下单方式:</span>
                        <label> <input type="radio" name="ciphertextOrderSet" value='1'/> 自动识别供应商是否支持密文下单，自动标记或取消</label>
                        <label> <input type="radio" name="ciphertextOrderSet"  value='0'/> 手动对供应商进行标记设置</label>
                        <a className='dColor hover' style={{marginLeft:'30px'}} href='https://docs.qq.com/doc/DYkFjV3R2TFZKUnZn?spm=a26370.isv_inner_8076003.0.0.2c43ftq3ftq37W' target='_blank'>了解详情</a>
                    </div>              
                </ShowModal> 

                <MyLoading isLoading={this.state.isLoading} isStopOperate={true} fullCenter={true} />
                {
                    this.state.isCategoryShow && this.state.isCategory ? 
                    <MyCascader 
                    isShow={this.state.isCategoryShow} 
                    options={this.state.isCategory} 
                    that={this.state.isCategoryThat} 
                    onchangecheck={(selectItem) => { return this.hideCategory(selectItem) }}
                    onCancel={() => { return this.setState({isCategoryShow:false}) }}
                    />
                    : null
                }
                
                {
                    this.state.isAliPoolCategoryShow && this.state.isAliPoolCategory ? 
                    <MyCascader 
                    isShow={this.state.isAliPoolCategoryShow} 
                    options={this.state.isAliPoolCategory} 
                    that={this.state.isAliPoolCategoryThat} 
                    onchangecheck={(selectItem) => { return this.hideAliPoolCategory(selectItem) }}
                    onCancel={() => { return this.setState({isAliPoolCategoryShow:false}) }}
                    />
                    : null
                }

                <NewUserGuide></NewUserGuide>
                {
                    this.state.showPreviewDistributionDailog ?
                        <PreviewDistributionList 
                                            targetPlatformType={getLoginShopInfo().loginShopPlatformType}
                                            targetShopId={getLoginShopInfo().loginShopId}
                                            showModal={this.state.showPreviewDistributionDailog} 
                                            productList={this.state.selectPreviewProductList}
                                            sureBatchPuhuo={this.previewSureBatchPuhuo} //点确定铺货按钮 函数
                                            cancelDailog={this.cancelPreviewDistribution} //点关闭铺货按钮 函数
                                        />: null
                }
                
            </div>
        );
    }
}

export default offerSearch;



// WEBPACK FOOTER //
// ./src/pages/offerSearch/offerSearch.jsx